
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1184931890 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"e","‰":"‰"},]);
Globalize.b542630194 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"e","‰":"‰"},]);
Globalize.b730970938 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"e","‰":"‰"},]);
Globalize.a304165453 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","e":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b908667006 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.b1878253058 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a687755338 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b471473328 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόρριψη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1830349678 = messageFormatterFn((function(  ) {
  return function(d) { return "Ολοκληρώθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a298106836 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a260304619 = messageFormatterFn((function(  ) {
  return function(d) { return "επιλεγμένη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a767700354 = messageFormatterFn((function(  ) {
  return function(d) { return "Γίνεται φόρτωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1888012013 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαλοιφή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1523165427 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανοίγει σε νέο παράθυρο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b500661337 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1994682036 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση λιγότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1139483216 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2027787651 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση λιγότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1309549198 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέχθηκε " + d["0"] + ". Τώρα επιλέξτε μια ημερομηνία αναχώρησης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1204337981 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέχθηκε " + d["0"] + ". Τώρα κάντε κλικ στο κουμπί " + d["1"] + " για να αποθηκεύσετε αυτές τις ημερομηνίες και να κλείσετε το εργαλείο επιλογής ημερομηνίας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1176187559 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", τρέχουσα ημερομηνία άφιξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1450864934 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", τρέχουσα ημερομηνία αναχώρησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b836859856 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", η ημερομηνία είναι απενεργοποιημένη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1436742419 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", τρέχων μήνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2086374504 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφανίζονται " + d["0"] + " και " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b220937508 = messageFormatterFn((function(  ) {
  return function(d) { return "Το εργαλείο επιλογής ημερομηνίας άνοιξε. Επιλέξτε μια ημερομηνία από τους πίνακες παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1390580530 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε και κλείστε το εργαλείο επιλογής ημερομηνίας χωρίς να αποθηκεύσετε τις αλλαγές. Διαφορετικά, επιλέξτε μια ημερομηνία από τους πίνακες παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2106364706 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαλοιφή επιλεγμένων ημερομηνιών."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1805408211 = messageFormatterFn((function(  ) {
  return function(d) { return "Αποθηκεύστε τις αλλαγές και κλείστε το εργαλείο επιλογής ημερομηνίας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2020631418 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " διανυκτερεύσεις";}, one: function() { return number(d["0"]) + " διανυκτέρευση";}, two: function() { return number(d["0"]) + " διανυκτερεύσεις";}, few: function() { return number(d["0"]) + " διανυκτερεύσεις";}, many: function() { return number(d["0"]) + " διανυκτερεύσεις";}, other: function() { return number(d["0"]) + " διανυκτερεύσεις";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1775787222 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1639058073 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a578761336 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαλοιφή ημερομηνιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2056645575 = messageFormatterFn((function(  ) {
  return function(d) { return "Τέλος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b868383571 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b258628957 = messageFormatterFn((function(  ) {
  return function(d) { return "Επεξεργασία της ημερομηνίας άφιξης στους πίνακες παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a655489332 = messageFormatterFn((function(  ) {
  return function(d) { return "Επεξεργασία της ημερομηνίας αναχώρησης στους πίνακες παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b378588483 = messageFormatterFn((function(  ) {
  return function(d) { return "επιλέχτηκε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1333919664 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέχθηκε " + d["0"] + ". Κλείστε το εργαλείο επιλογής ημερομηνίας ή συνεχίστε στην αλλαγή της επιλεγμένης ημερομηνίας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1708740008 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέχθηκε από " + d["0"] + " έως " + d["1"] + ". Κλείστε το εργαλείο επιλογής ημερομηνίας ή συνεχίστε στην αλλαγή των επιλεγμένων ημερομηνιών."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b479178850 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέχθηκε " + d["0"] + ". " + d["1"] + ". Κλείστε το εργαλείο επιλογής ημερομηνίας ή συνεχίστε στην αλλαγή της επιλεγμένης ημερομηνίας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b641571290 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέχθηκε από " + d["0"] + " έως " + d["1"] + ". " + d["2"] + ". Κλείστε το εργαλείο επιλογής ημερομηνίας ή συνεχίστε στην αλλαγή των επιλεγμένων ημερομηνιών."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1024479617 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία έναρξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b517359110 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία λήξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1762263273 = messageFormatterFn((function(  ) {
  return function(d) { return "κενό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b638162809 = messageFormatterFn((function(  ) {
  return function(d) { return "Προηγούμενος μήνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1373445525 = messageFormatterFn((function(  ) {
  return function(d) { return "Επόμενος μήνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a890472644 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση στο κουμπί " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b585772132 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " έως " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1345531423 = messageFormatterFn((function(  ) {
  return function(d) { return "Έγινε απαλοιφή των ημερομηνιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1228869844 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return "υπάρχουν " + number(d["0"]) + " αποτελέσματα";}, one: function() { return "υπάρχει " + number(d["0"]) + " αποτέλεσμα";}, two: function() { return "υπάρχουν " + number(d["0"]) + " αποτελέσματα";}, few: function() { return "υπάρχουν " + number(d["0"]) + " αποτελέσματα";}, many: function() { return "υπάρχουν " + number(d["0"]) + " αποτελέσματα";}, other: function() { return "υπάρχουν " + number(d["0"]) + " αποτελέσματα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1738164917 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "«" + d["0"] + "» " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return "Διατίθενται " + number(d["1"]) + " αποτελέσματα";}, one: function() { return "Διατίθεται " + number(d["1"]) + " αποτέλεσμα";}, two: function() { return "Διατίθενται " + number(d["1"]) + " αποτελέσματα";}, few: function() { return "Διατίθενται " + number(d["1"]) + " αποτελέσματα";}, many: function() { return "Διατίθενται " + number(d["1"]) + " αποτελέσματα";}, other: function() { return "Διατίθενται " + number(d["1"]) + " αποτελέσματα";} }) + ". Χρησιμοποιήστε τα πλήκτρα με βέλη ή κάντε σάρωση για να πλοηγηθείτε στη λίστα."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b709753815 = messageFormatterFn((function(  ) {
  return function(d) { return "Η αναζήτηση για " + d["0"] + " είναι ανοικτή. Καταχωρίστε όρο αναζήτησης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2059178906 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξατε " + d["0"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a611859779 = messageFormatterFn((function(  ) {
  return function(d) { return "Το μενού είναι κλειστό."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b724121079 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Η αναζήτηση για " + d["0"] + " είναι ανοικτή. " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, one: function() { return "Εμφανίζεται " + number(d["1"]) + " πρόταση";}, two: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, few: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, many: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, other: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";} }) + " για " + d["2"] + ". Πλοηγηθείτε στην παρακάτω λίστα."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a851569934 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Η αναζήτηση για " + d["0"] + " είναι ανοικτή. " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, one: function() { return "Εμφανίζεται " + number(d["1"]) + " πρόταση";}, two: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, few: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, many: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";}, other: function() { return "Εμφανίζονται " + number(d["1"]) + " προτάσεις";} }) + ". Καταχωρίστε όρο αναζήτησης ή πλοηγηθείτε στη λίστα παρακάτω."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1060336586 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Η αναζήτηση για " + d["0"] + " είναι ανοικτή. Έχει επιλεγεί " + d["1"] + ". " + plural(d["2"], 0, pluralFuncs["el-GR"], { zero: function() { return "Εμφανίζονται " + number(d["2"]) + " προτάσεις";}, one: function() { return "Εμφανίζεται " + number(d["2"]) + " πρόταση";}, two: function() { return "Εμφανίζονται " + number(d["2"]) + " προτάσεις";}, few: function() { return "Εμφανίζονται " + number(d["2"]) + " προτάσεις";}, many: function() { return "Εμφανίζονται " + number(d["2"]) + " προτάσεις";}, other: function() { return "Εμφανίζονται " + number(d["2"]) + " προτάσεις";} }) + " για " + d["3"] + ". Πλοηγηθείτε στην παρακάτω λίστα."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a181104112 = messageFormatterFn((function(  ) {
  return function(d) { return "Τέλος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1440502617 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαγραφή όλων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1184263738 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλεγμένα στοιχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b474768761 = messageFormatterFn((function(  ) {
  return function(d) { return "Καταργήθηκε η επιλογή " + d["0"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2025155534 = messageFormatterFn((function(  ) {
  return function(d) { return "Όλες οι επιλογές καταργήθηκαν."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a971793407 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρίσκεστε στο πεδίο εισαγωγής κειμένου. Αναζητήστε ή επιλέξτε μία από τις προτεινόμενες κατηγορίες παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b583687200 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση «" + d["0"] + "»"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b823135329 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν βρέθηκαν αποτελέσματα για «" + d["0"] + "»"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b868497483 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b444131810 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a650488052 = messageFormatterFn((function(  ) {
  return function(d) { return "Σημείο ενδιαφέροντος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a683717795 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε κοντινή απόσταση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a450919450 = messageFormatterFn((function(  ) {
  return function(d) { return "Δοκιμάστε «" + d["0"] + "»"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b702494325 = messageFormatterFn((function(  ) {
  return function(d) { return "Περιοχή/Πόλη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1273681407 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a502718663 = messageFormatterFn((function(  ) {
  return function(d) { return "Αξιοθέατο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a11311978 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b889896214 = messageFormatterFn((function(  ) {
  return function(d) { return "Διεύθυνση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a413082860 = messageFormatterFn((function(  ) {
  return function(d) { return "Σταθμός τρένων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1855304453 = messageFormatterFn((function(  ) {
  return function(d) { return "Σταθμός μετρό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1400332383 = messageFormatterFn((function(  ) {
  return function(d) { return "Κοντινοί προορισμοί"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b38935670 = messageFormatterFn((function(  ) {
  return function(d) { return "Πρόσφατες αναζητήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a690219824 = messageFormatterFn((function(  ) {
  return function(d) { return "Οι επισκέπτες της σελίδας αναζήτησαν επίσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1659487301 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξερευνήστε δημοφιλείς προορισμούς"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1911059599 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοφιλείς προορισμοί"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1931787123 = messageFormatterFn((function(  ) {
  return function(d) { return "Τάσεις προορισμών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a652554255 = messageFormatterFn((function(  ) {
  return function(d) { return "Η τοποθεσία σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1781631628 = messageFormatterFn((function(  ) {
  return function(d) { return "Η κοινοποίηση τοποθεσίας είναι απενεργοποιημένη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a140253764 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν μπορέσαμε να προσδιορίσουμε την τοποθεσία σας. Ενεργοποιήστε την υπηρεσία εντοπισμού τοποθεσίας στη συσκευή σας, για να προσδιορίσουμε την τοποθεσία σας ή πληκτρολογήστε έναν προορισμό."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a411417312 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωμάτια";}, one: function() { return number(d["0"]) + " δωμάτιο";}, two: function() { return number(d["0"]) + " δωμάτια";}, few: function() { return number(d["0"]) + " δωμάτια";}, many: function() { return number(d["0"]) + " δωμάτια";}, other: function() { return number(d["0"]) + " δωμάτια";} }) + ", " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " ταξιδιώτες";}, one: function() { return number(d["1"]) + " ταξιδιώτης";}, two: function() { return number(d["1"]) + " ταξιδιώτες";}, few: function() { return number(d["1"]) + " ταξιδιώτες";}, many: function() { return number(d["1"]) + " ταξιδιώτες";}, other: function() { return number(d["1"]) + " ταξιδιώτες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1795850378 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ταξιδιώτες";}, one: function() { return number(d["0"]) + " ταξιδιώτης";}, two: function() { return number(d["0"]) + " ταξιδιώτες";}, few: function() { return number(d["0"]) + " ταξιδιώτες";}, many: function() { return number(d["0"]) + " ταξιδιώτες";}, other: function() { return number(d["0"]) + " ταξιδιώτες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1095425874 = messageFormatterFn((function(  ) {
  return function(d) { return "Η τιμή του πεδίου " + d["0"] + " είναι τώρα " + d["1"] + ". Η τιμή του πεδίου " + d["2"] + " είναι τώρα " + d["3"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1352586909 = messageFormatterFn((function(  ) {
  return function(d) { return "Εναλλαγή των πεδίων " + d["0"] + " και " + d["1"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1127353718 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση κωδικού πρόσβασης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a813011579 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόκρυψη κωδικού πρόσβασης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a754421620 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφανίζεται: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1440383839 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " από " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2018655307 = messageFormatterFn((function(  ) {
  return function(d) { return "Εικόνα " + d["0"] + " από " + d["1"] + ". " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1837528434 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή επόμενης εικόνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b378275474 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή προηγούμενης εικόνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1914945492 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Εμφάνιση " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " εικόνων";}, one: function() { return number(d["0"]) + " εικόνας";}, two: function() { return number(d["0"]) + " εικόνων";}, few: function() { return "και των " + number(d["0"]) + " εικόνων";}, many: function() { return "και των " + number(d["0"]) + " εικόνων";}, other: function() { return "και των " + number(d["0"]) + " εικόνων";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1459548873 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Εμφάνιση " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " εικόνων";}, one: function() { return number(d["0"]) + " εικόνας";}, two: function() { return number(d["0"]) + " εικόνων";}, few: function() { return "και των " + number(d["0"]) + " εικόνων";}, many: function() { return "και των " + number(d["0"]) + " εικόνων";}, other: function() { return "και των " + number(d["0"]) + " εικόνων";} }) + " για το δωμάτιο " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2011159558 = messageFormatterFn((function(  ) {
  return function(d) { return "Ολοκληρώθηκε:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a927436724 = messageFormatterFn((function(  ) {
  return function(d) { return "Τρέχουσα εργασία:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1276513822 = messageFormatterFn((function(  ) {
  return function(d) { return "Βήμα " + d["0"] + " από " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1682659974 = messageFormatterFn((function(  ) {
  return function(d) { return "Βήμα " + d["0"] + " από " + d["1"] + ":"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2101573691 = messageFormatterFn((function(  ) {
  return function(d) { return "Εικόνα " + d["0"] + " από " + d["1"] + ". " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1743491960 = messageFormatterFn((function(  ) {
  return function(d) { return "Επόμενη εικόνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b798055308 = messageFormatterFn((function(  ) {
  return function(d) { return "Προηγούμενη εικόνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1941088454 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", μπορείτε να την αναπτύξετε σε πλήρη οθόνη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2068263910 = messageFormatterFn((function(  ) {
  return function(d) { return "Στοιχείο " + d["0"] + ", μπορείτε να το αναπτύξετε σε πλήρη οθόνη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b780797360 = messageFormatterFn((function(  ) {
  return function(d) { return "Τρέχουσα σελίδα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b771802400 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων τμημάτων διαδρομής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b809623516 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση λιγότερων τμημάτων διαδρομής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1139926457 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " τοις εκατό φορτώθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1788318722 = messageFormatterFn((function(  ) {
  return function(d) { return "Γίνεται φόρτωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a370327150 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a661359557 = messageFormatterFn((function(  ) {
  return function(d) { return "Παρουσιάστηκε ένα σφάλμα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1073977065 = messageFormatterFn((function(  ) {
  return function(d) { return "Δοκιμάστε να παρακολουθήσετε αυτό το βίντεο στη διεύθυνση www.youtube.com ή ενεργοποιήστε τη Javascript αν είναι απενεργοποιημένη στο πλοηγό ίντερνετ που χρησιμοποιείτε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b156455377 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναπαραγωγή βίντεο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1305934303 = messageFormatterFn((function(  ) {
  return function(d) { return "Παύση βίντεο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b124628743 = messageFormatterFn((function(  ) {
  return function(d) { return "Το βίντεο φορτώνεται"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b655249553 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτόσφαιρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1417648041 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτή είναι μια εικόνα 360 μοιρών. Χρησιμοποιήστε το πλήκτρο control και τα πλήκτρα με τα βέλη ή το πλήκτρο command και τα πλήκτρα με τα βέλη για να μετακινηθείτε εντός της εικόνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b214989188 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφανίζεται: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1159234533 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετακίνηση προς τα αριστερά. Θέση: " + d["0"] + " μοίρες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b431317666 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετακίνηση προς τα δεξιά. Θέση: " + d["0"] + " μοίρες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a530913263 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετακίνηση προς τα επάνω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1378531850 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετακίνηση προς τα κάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1584766969 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρίσκεστε στην κορυφή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a397328349 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρίσκεστε στο κάτω μέρος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1564421169 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλογή όλων των σειρών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1115302544 = messageFormatterFn((function(  ) {
  return function(d) { return "Αποεπιλογή όλων των σειρών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2070553440 = messageFormatterFn((function(  ) {
  return function(d) { return "Ταξινόμηση στήλης κατά φθνίσουσα σειρά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1928476538 = messageFormatterFn((function(  ) {
  return function(d) { return "Ταξινόμηση στήλης κατά αύξουσα σειρά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b560065834 = messageFormatterFn((function(  ) {
  return function(d) { return "Η στήλη εμφανίζεται τώρα κατά φθίνουσα σειρά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1410089710 = messageFormatterFn((function(  ) {
  return function(d) { return "Η στήλη εμφανίζεται τώρα κατά αύξουσα σειρά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1285651254 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανάπτυξη σειράς " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1451159925 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Εμφανίζονται " + d["0"] + " από " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " στοιχεία";}, one: function() { return number(d["1"]) + " στοιχείο";}, two: function() { return number(d["1"]) + " στοιχεία";}, few: function() { return number(d["1"]) + " items";}, many: function() { return number(d["1"]) + " στοιχεία";}, other: function() { return number(d["1"]) + " στοιχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b709115301 = messageFormatterFn((function(  ) {
  return function(d) { return "οι τρέχοντες μήνες σας είναι " + d["0"] + " " + d["1"] + " και " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1956399373 = messageFormatterFn((function(  ) {
  return function(d) { return "ο τρέχων μήνας σας είναι " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1308474498 = messageFormatterFn((function(  ) {
  return function(d) { return "οι τρέχοντες μήνες σας είναι " + d["0"] + " " + d["1"] + " έως " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1340539907 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία άφιξης εκκαθαρίστηκε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1801155020 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία αναχώρησης εκκαθαρίστηκε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b750030485 = messageFormatterFn((function(  ) {
  return function(d) { return "Οι ημερομηνίες εκκαθαρίστηκαν."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b908009338 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαλοιφή ημερομηνιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b298121754 = messageFormatterFn((function(  ) {
  return function(d) { return "Υποβολή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b753816119 = messageFormatterFn((function(  ) {
  return function(d) { return "Επόμενο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b298617591 = messageFormatterFn((function(  ) {
  return function(d) { return "Προηγούμενο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1732613585 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση στο κουμπί Υποβολή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1202127390 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση στο κουμπί " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1595463155 = messageFormatterFn((function(  ) {
  return function(d) { return "Επόμενος μήνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1409280717 = messageFormatterFn((function(  ) {
  return function(d) { return "Προηγούμενος μήνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a15884694 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία " + d["0"] + " έχει επιλεχθεί ως η ημερομηνία άφιξής σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1407589765 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία " + d["0"] + " έχει επιλεχθεί ως η ημερομηνία αναχώρησής σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1803981646 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία " + d["0"] + " δεν είναι έγκυρη ημερομηνία άφιξης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a332141523 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία " + d["0"] + " δεν είναι έγκυρη ημερομηνία αναχώρησης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b273232258 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία " + d["0"] + " δεν είναι διαθέσιμη."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a706573231 = messageFormatterFn((function(  ) {
  return function(d) { return "Σήμερα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1725415213 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλεγμένη ημερομηνία check-in"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b25939828 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλεγμένη ημερομηνία check-out"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1896227095 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλεγμένη ημερομηνία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a840555973 = messageFormatterFn((function(  ) {
  return function(d) { return "Από"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a670149054 = messageFormatterFn((function(  ) {
  return function(d) { return "Έως"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b196548159 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε και κλείστε το εργαλείο επιλογής ημερομηνίας χωρίς να αποθηκεύσετε τις αλλαγές. Εναλλακτικά, επιλέξτε μια ημερομηνία από τους πίνακες παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b273147120 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " στα " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a217361125 = messageFormatterFn((function(  ) {
  return function(d) { return "Πατήστε το πλήκτρο escape για κλείσιμο."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2018747762 = messageFormatterFn((function(  ) {
  return function(d) { return "Πατήστε το πλήκτρο escape για σύμπτυξη."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1627126301 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληκτρολογήστε έναν αριθμό μικρότερο από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1451683708 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληκτρολογήστε έναν αριθμό μεγαλύτερο από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1452374065 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληκτρολογήστε έναν αριθμό μεταξύ " + d["0"] + " και " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2103281470 = messageFormatterFn((function(  ) {
  return function(d) { return "Υποχρεωτικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a73694836 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαγραφή της τοποθεσίας " + d["0"] + " από τις πρόσφατες αναζητήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a189309745 = messageFormatterFn((function(  ) {
  return function(d) { return "Η τοποθεσία " + d["0"] + " διαγράφηκε από τις πρόσφατες αναζητήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b711679735 = messageFormatterFn((function(  ) {
  return function(d) { return "Μέσα μεταφοράς"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a210952437 = messageFormatterFn((function(  ) {
  return function(d) { return "Κατάλυμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1522334390 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Ξεκλειδώστε τιμές μόνο για τα μέλη!" + d["1"] + " Μπορείτε να εξοικονομήσετε " + d["2"] + "% κατά μέσο όρο σε χιλιάδες ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1341869724 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Ξεκλειδώστε τιμές μόνο για τα μέλη!" + d["1"] + " Μπορείτε να εξοικονομήσετε " + d["2"] + "% ή περισσότερο σε χιλιάδες ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a114021761 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Κερδίστε 1 διανυκτέρευση επιβράβευσης*" + d["1"] + " για κάθε 10 διανυκτερεύσεις που ολοκληρώνετε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a989260242 = messageFormatterFn((function(  ) {
  return function(d) { return "Μάθετε περισσότερα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b982508614 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Κερδίστε ανταμοιβές" + d["1"] + " σε πάνω από 1.000.000 καταλύματα σε όλον τον κόσμο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1781893804 = messageFormatterFn((function(  ) {
  return function(d) { return "ΕΓΓΡΑΦΗ ΤΩΡΑ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1254048880 = messageFormatterFn((function(  ) {
  return function(d) { return "ΣΥΝΔΕΣΗ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b459175623 = messageFormatterFn((function(  ) {
  return function(d) { return "*Δείτε περισσότερες λεπτομέρειες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a950752483 = messageFormatterFn((function(  ) {
  return function(d) { return "*Δείτε τους όρους και τις προϋποθέσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b808236852 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Ξεκλειδώστε Μυστικές τιμές!" + d["1"] + " Θα μπορούσατε να κερδίσετε έκπτωση 10%"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1625206896 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1994397345 = messageFormatterFn((function(  ) {
  return function(d) { return "Όλα τα ξενοδοχεία με αξιολόγηση με αστέρια " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1514841670 = messageFormatterFn((function(  ) {
  return function(d) { return "Έλεγχος τιμών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b801456342 = messageFormatterFn((function(  ) {
  return function(d) { return "Έλεγχος διαθεσιμότητας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1315520167 = messageFormatterFn((function(  ) {
  return function(d) { return "Έλεγχος κόστους"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2025195555 = messageFormatterFn((function(  ) {
  return function(d) { return "Εύρεση προσφορών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a847212991 = messageFormatterFn((function(  ) {
  return function(d) { return "Εύρεση ξενοδοχείων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a593162034 = messageFormatterFn((function(  ) {
  return function(d) { return "Εύρεση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a878113331 = messageFormatterFn((function(  ) {
  return function(d) { return "Εύρεση ενοικιαζόμενων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a862516906 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε πού θα μείνετε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1014878702 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1053442876 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε προσφορές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1795723840 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b67772719 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b899028428 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε ενοικιαζόμενα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a390989355 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε μέρη να μείνετε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1459716146 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση προσφορών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1197205486 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση ξενοδοχείων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1441972509 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b56706846 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση ενοικιαζόμενων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1879035353 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείξτε μου μέρη για να μείνω"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2046560981 = messageFormatterFn((function(  ) {
  return function(d) { return "Δώστε μου ιδέες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2017653080 = messageFormatterFn((function(  ) {
  return function(d) { return "Εκπλήξτε με"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1804571302 = messageFormatterFn((function(  ) {
  return function(d) { return "Δώστε μου χαρά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b734591426 = messageFormatterFn((function(  ) {
  return function(d) { return "Πακέτα καταλυμάτων και πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b734536649 = messageFormatterFn((function(  ) {
  return function(d) { return "Πακέτα καταλυμάτων και αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b734596231 = messageFormatterFn((function(  ) {
  return function(d) { return "Πακέτα πτήσεων και αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1297436997 = messageFormatterFn((function(  ) {
  return function(d) { return "Πακέτα καταλυμάτων, πτήσεων και αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1506786220 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε δύο ή περισσότερα στοιχεία και εξοικονομήστε στο ταξίδι σας:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1953193300 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε ένα ή περισσότερα στοιχεία για να δημιουργήσετε το ταξίδι σας:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1698798773 = messageFormatterFn((function(  ) {
  return function(d) { return "Συνδυάστε και εξοικονομήστε χρήματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2040985527 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1270492274 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη διαμονής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a524342311 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a783506349 = messageFormatterFn((function(  ) {
  return function(d) { return "Η πτήση προστέθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b199983146 = messageFormatterFn((function(  ) {
  return function(d) { return "Η διαμονή προστέθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b946133109 = messageFormatterFn((function(  ) {
  return function(d) { return "Το αυτοκίνητο προστέθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b117141977 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή χωρίς χρήση πόντων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b460727913 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή με πόντους"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2145666214 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή με μίλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1502597381 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1354578339 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη καταλύματος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a32121961 = messageFormatterFn((function(  ) {
  return function(d) { return "Το ξενοδοχείο προστέθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b115897081 = messageFormatterFn((function(  ) {
  return function(d) { return "Το κατάλυμα προστέθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1653208503 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1256474522 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κατά προορισμό, κατάλυμα ή σημείο ενδιαφέροντος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1870275616 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κατά πόλη ή αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b356803462 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κατά πόλη, αεροδρόμιο ή διεύθυνση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1831524187 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κατά πόλη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1091975561 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού πηγαίνετε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b858102865 = messageFormatterFn((function(  ) {
  return function(d) { return "Από πού φεύγετε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a213017659 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού πηγαίνετε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2015590583 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού θα παραλάβετε το αυτοκίνητό σας;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1023680549 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού θα επιστρέψετε το αυτοκίνητό σας;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1419491170 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε ένα ή περισσότερα στοιχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1240065478 = messageFormatterFn((function(  ) {
  return function(d) { return "Για να αρχίσετε να δημιουργείτε το ταξίδι σας, επιλέξτε ένα ή περισσότερα στοιχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1805751041 = messageFormatterFn((function(  ) {
  return function(d) { return "Για συμβουλές για κρουαζιέρες από ειδικούς, καλέστε στο " + d["0"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1265923495 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε κατάλυμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1845363734 = messageFormatterFn((function(  ) {
  return function(d) { return "Κατάλυμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b55150139 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε και συγκρίνετε πτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1657916779 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξοικονομήστε με πακέτα διακοπών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1194614855 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε και συγκρίνετε προσφορές ενοικίασης αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1733407957 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1688817798 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση καταλύματος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1457817006 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2104050600 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημιουργήστε ένα πακέτο διακοπών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b739183910 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση προσφορών ενοικίασης αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a621595944 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση δραστηριοτήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1996666336 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητήστε και συγκρίνετε πτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1818851802 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξοικονομήστε με πακέτα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b690482676 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενοικίαση μεταφορικού μέσου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1135572903 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2114537199 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a417646896 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κοντινών αποδράσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a427625143 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ενοικιαζόμενων κατοικιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2129171919 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b28370803 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή με μίλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b170323299 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή με μίλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1593192412 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή με μίλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a888930534 = messageFormatterFn((function(  ) {
  return function(d) { return "Χρήση μιλίων MileagePlus"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1260797238 = messageFormatterFn((function(  ) {
  return function(d) { return "Χρήση μιλίων MileagePlus"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1468185514 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή με μίλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2013160282 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληρωμή με μίλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1086853023 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b763892096 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κοντινών αποδράσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1365813241 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ενοικιαζόμενων κατοικιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1797376639 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a737868940 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b498474317 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ξενοδοχείων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1982764090 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση + Ξενοδοχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a879620961 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση για πτήση + ξενοδοχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a29376826 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1281381648 = messageFormatterFn((function(  ) {
  return function(d) { return "Διακοπές στην παραλία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1274856740 = messageFormatterFn((function(  ) {
  return function(d) { return "Πάνω από τη μέση τιμή."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b535966488 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάτω από τη μέση τιμή."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b568747712 = messageFormatterFn((function(  ) {
  return function(d) { return "Υψηλότερες τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a387499524 = messageFormatterFn((function(  ) {
  return function(d) { return "Χαμηλότερες τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1720364324 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληροφορίες τάσεων τιμών από τα πρώτα " + d["0"] + " καταλύματα σε αυτήν τη σελίδα, με βάση τις τιμές διανυκτέρευσης για 2 ενήλικες που βρέθηκαν τις τελευταίες 24 ώρες στην ιστοσελίδα μας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2089204272 = messageFormatterFn((function(  ) {
  return function(d) { return "Μικρο-μεσαίο οικογενειακό αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a766388875 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1314707065 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτοκίνητο πλήρους μεγέθους (full-size)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1862598326 = messageFormatterFn((function(  ) {
  return function(d) { return "Πολυτελές αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a23949270 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτοκίνητο μεσαίου μεγέθους"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a34029625 = messageFormatterFn((function(  ) {
  return function(d) { return "Πολυμορφικό όχημα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b507878563 = messageFormatterFn((function(  ) {
  return function(d) { return "Άλλο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1868396133 = messageFormatterFn((function(  ) {
  return function(d) { return "Παραλαβή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1882435484 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1234228766 = messageFormatterFn((function(  ) {
  return function(d) { return "Σπορ αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b85615898 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτοκίνητο κανονικού μεγέθους"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1990087135 = messageFormatterFn((function(  ) {
  return function(d) { return "SUV"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1987920080 = messageFormatterFn((function(  ) {
  return function(d) { return "Βαν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a575076929 = messageFormatterFn((function(  ) {
  return function(d) { return "Τύπος αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1012328370 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχετε κάποιο ταξίδι κατά νου;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1637151432 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητήστε πτήσεις, ξενοδοχεία, πακέτα και άλλα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1499391243 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήσεις, ξενοδοχεία, πακέτα και άλλα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a369891110 = messageFormatterFn((function(  ) {
  return function(d) { return "Να συμπεριλαμβάνονται τιμές πακέτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1023231002 = messageFormatterFn((function(  ) {
  return function(d) { return "Λαμβάνετε ειδικές αποκλειστικές τιμές για καταλύματα, όταν γίνεται κράτηση σε συνδυασμό με πτήση, αυτοκίνητο, τρένο ή κρουαζιέρα για τον ταξιδιώτη σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a698703381 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/5"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1911238629 = messageFormatterFn((function(  ) {
  return function(d) { return "Επαληθευμένο σχόλιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a317028128 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " από " + d["1"] + " έμειναν στο " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b852149719 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " έμεινε στο " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1638396052 = messageFormatterFn((function(  ) {
  return function(d) { return "Ένας επαληθευμένος ταξιδιώτης από " + d["0"] + " διέμεινε σε " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b915359139 = messageFormatterFn((function(  ) {
  return function(d) { return "Ένας επαληθευμένος ταξιδιώτης διέμεινε σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1685298548 = messageFormatterFn((function(  ) {
  return function(d) { return "Άνοιγμα σχολίων πελατών του " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a333869293 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοσιεύθηκε λιγότερο από μία ώρα πριν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b587584287 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Δημοσιεύτηκε πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b2016900031 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Δημοσιεύτηκε πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ημέρες";}, one: function() { return number(d["0"]) + " ημέρα";}, two: function() { return number(d["0"]) + " ημέρες";}, few: function() { return number(d["0"]) + " ημέρες";}, many: function() { return number(d["0"]) + " ημέρες";}, other: function() { return number(d["0"]) + " ημέρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1916603121 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Δημοσιεύτηκε πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " εβδομάδες";}, one: function() { return number(d["0"]) + " εβδομάδα";}, two: function() { return number(d["0"]) + " εβδομάδες";}, few: function() { return number(d["0"]) + " εβδομάδες";}, many: function() { return number(d["0"]) + " εβδομάδες";}, other: function() { return number(d["0"]) + " εβδομάδες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2046425893 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Δημοσιεύτηκε πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " μήνες";}, one: function() { return number(d["0"]) + " μήνα";}, two: function() { return number(d["0"]) + " μήνες";}, few: function() { return number(d["0"]) + " μήνες";}, many: function() { return number(d["0"]) + " μήνες";}, other: function() { return number(d["0"]) + " μήνες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1739002285 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοσιεύθηκε πριν 1 χρόνο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a545086375 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοσιεύθηκε πάνω από 1 χρόνο πριν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b859049899 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " στα 5"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a151092045 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/5"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a88286788 = messageFormatterFn((function(  ) {
  return function(d) { return "Άριστο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1182706939 = messageFormatterFn((function(  ) {
  return function(d) { return "Καλό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b957764708 = messageFormatterFn((function(  ) {
  return function(d) { return "Ικανοποιητικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b925031126 = messageFormatterFn((function(  ) {
  return function(d) { return "Κακό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b707750261 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαίσιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a801858100 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " επαληθευμένα σχόλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1386756981 = messageFormatterFn((function(  ) {
  return function(d) { return "Σχόλια πελατών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b477737437 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση και επιστροφή στις λεπτομέρειες ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1406030916 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξασφαλίστε τις καλύτερες προσφορές σε " + d["0"] + ", " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b43311071 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξασφαλίστε τις καλύτερες προσφορές κοντά σε " + d["0"] + ", " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1541417245 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτό το σαββατοκύριακο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a4502788 = messageFormatterFn((function(  ) {
  return function(d) { return "Το φτηνότερο σαββατοκύριακο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a540905781 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόψε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1972960132 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές κοντά σε " + d["0"] + " για απόψε, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b222914017 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές σε " + d["0"] + " για απόψε, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1505520878 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές σε " + d["0"] + " για το επόμενο σαββατοκύριακο, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1856414574 = messageFormatterFn((function(  ) {
  return function(d) { return "Καλύτερη προσφορά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b442281609 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές κοντά σε " + d["0"] + " για το επόμενο σαββατοκύριακο, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1807159281 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές σε " + d["0"] + " για αύριο το βράδυ, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1533607016 = messageFormatterFn((function(  ) {
  return function(d) { return "Το επόμενο σαββατοκύριακο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a712090631 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές σε " + d["0"] + " γι' αυτό το σαββατοκύριακο, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b713588906 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές κοντά σε " + d["0"] + " για αύριο το βράδυ, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1874498343 = messageFormatterFn((function(  ) {
  return function(d) { return "Λήψη τιμής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1460188025 = messageFormatterFn((function(  ) {
  return function(d) { return "Αύριο βράδυ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2009096852 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές κοντά σε " + d["0"] + " γι' αυτό το σαββατοκύριακο, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b821004102 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε δύο εβδομάδες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2026493513 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές κοντά σε " + d["0"] + " για το σαββατοκύριακο σε δύο εβδομάδες, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b149091868 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές σε " + d["0"] + " για το σαββατοκύριακο σε δύο εβδομάδες, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b989691231 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε έναν μήνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b353042448 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές κοντά σε " + d["0"] + " για το σαββατοκύριακο σε έναν μήνα, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a56871563 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές σε " + d["0"] + " για το σαββατοκύριακο σε έναν μήνα, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a621267118 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε δύο μήνες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b311678147 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές κοντά σε " + d["0"] + " για το σαββατοκύριακο σε δύο μήνες, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a797807320 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές σε " + d["0"] + " για το σαββατοκύριακο σε δύο μήνες, " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1882819956 = messageFormatterFn((function(  ) {
  return function(d) { return "Εφαρμογή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1539971362 = messageFormatterFn((function(  ) {
  return function(d) { return "Γίνεται φόρτωση αποτελεσμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a325201228 = messageFormatterFn((function(  ) {
  return function(d) { return "Τα αποτελέσματα ενημερώθηκαν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a632456290 = messageFormatterFn((function(  ) {
  return function(d) { return "Ειδοποίηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1768456424 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανοίγει σε νέο παράθυρο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b583332921 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1208441424 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ξενοδοχείων και πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1448411864 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ξενοδοχείων και αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b885760681 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ξενοδοχείων, πτήσεων και αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b756445974 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε διαθεσιμότητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b605888743 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1212016402 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε προσφορές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1297548614 = messageFormatterFn((function(  ) {
  return function(d) { return "Για να συνεχίσετε, διορθώστε τα παρακάτω σφάλματα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a408938505 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Για να συνεχίσετε, διορθώστε " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return "τα παρακάτω " + number(d["0"]) + " σφάλματα";}, one: function() { return "το παρακάτω " + number(d["0"]) + " σφάλμα";}, two: function() { return "τα παρακάτω " + number(d["0"]) + " σφάλματα";}, few: function() { return "τα παρακάτω " + number(d["0"]) + " σφάλματα";}, many: function() { return "τα παρακάτω " + number(d["0"]) + " σφάλματα";}, other: function() { return "τα παρακάτω " + number(d["0"]) + " σφάλματα";} }) + "."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a686711855 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση στο σφάλμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a698834116 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση στο πρώτο σφάλμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1042486869 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "-" + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " διανυκτερεύσεις";}, one: function() { return number(d["1"]) + " διανυκτέρευση";}, two: function() { return number(d["1"]) + " διανυκτερεύσεις";}, few: function() { return number(d["1"]) + " διανυκτερεύσεις";}, many: function() { return number(d["1"]) + " διανυκτερεύσεις";}, other: function() { return number(d["1"]) + " διανυκτερεύσεις";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1752951553 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλογή ημερομηνίας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b503879907 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλογή ημερομηνιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1046472035 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία άφιξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1775524588 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία αναχώρησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1998085156 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθέστε ημερομηνία αναχώρησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2069816389 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία αναχώρησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1944270839 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2038068021 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία παραλαβής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1247278089 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία παράδοσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2100721456 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία έναρξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b496058305 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια έγκυρη ημερομηνία λήξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b519999303 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία check-in σας πρέπει να πέφτει μέσα στις ημερομηνίες αναχώρησης και επιστροφής σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1112220844 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία check-out σας πρέπει να πέφτει μέσα στις ημερομηνίες αναχώρησης και επιστροφής σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1852221317 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία check-in σας πρέπει να πέφτει μέσα στην ημερομηνία αναχώρησης ή αργότερα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b897018160 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Οι ημερομηνίες δεν πρέπει να απέχουν περισσότερο από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ημέρες";}, one: function() { return number(d["0"]) + " ημέρα";}, two: function() { return number(d["0"]) + " ημέρες";}, few: function() { return number(d["0"]) + " ημέρες";}, many: function() { return number(d["0"]) + " ημέρες";}, other: function() { return number(d["0"]) + " ημέρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a152135512 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία αναχώρησης πρέπει να είναι μεταγενέστερη της ημερομηνίας άφιξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b734708535 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία αναχώρησης πρέπει να είναι εντός 28 ημερών από την ημερομηνία άφιξης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1283807689 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωμάτια";}, one: function() { return number(d["0"]) + " δωμάτιο";}, two: function() { return number(d["0"]) + " δωμάτια";}, few: function() { return number(d["0"]) + " δωμάτια";}, many: function() { return number(d["0"]) + " δωμάτια";}, other: function() { return number(d["0"]) + " δωμάτια";} }) + ", " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " ταξιδιώτες";}, one: function() { return number(d["1"]) + " ταξιδιώτης";}, two: function() { return number(d["1"]) + " ταξιδιώτες";}, few: function() { return number(d["1"]) + " ταξιδιώτες";}, many: function() { return number(d["1"]) + " ταξιδιώτες";}, other: function() { return number(d["1"]) + " ταξιδιώτες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b613248112 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ταξιδιώτες";}, one: function() { return number(d["0"]) + " ταξιδιώτης";}, two: function() { return number(d["0"]) + " ταξιδιώτες";}, few: function() { return number(d["0"]) + " ταξιδιώτες";}, many: function() { return number(d["0"]) + " ταξιδιώτες";}, other: function() { return number(d["0"]) + " ταξιδιώτες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1283009594 = messageFormatterFn((function(  ) {
  return function(d) { return "Ταξιδιώτες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b738049188 = messageFormatterFn((function(  ) {
  return function(d) { return "Επισκέπτες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1566518052 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε και κλείστε το εργαλείο επιλογής ταξιδιώτη χωρίς να αποθηκεύσετε τις αλλαγές. Εναλλακτικά, επεξεργαστείτε τα στοιχεία των ταξιδιωτών παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a797641400 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη άλλου δωματίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1478425038 = messageFormatterFn((function(  ) {
  return function(d) { return "Ζητήστε πάνω από 9 δωμάτια ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b315961402 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενήλικες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1546015121 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικία παιδιού " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b475017623 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικία βρέφους " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1865930359 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικίας 0 έως 17 ετών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a205740930 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικίας 2 έως 17 ετών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a374125129 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάτω των 2 ετών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a773700496 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάτω του 1 έτους"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1160251904 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρέφη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a513918656 = messageFormatterFn((function(  ) {
  return function(d) { return "Παιδιά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b431276266 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικίας 12+"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1290429724 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικίας 2 έως 11 ετών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1879361450 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάτω των 2 ετών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1442323080 = messageFormatterFn((function(  ) {
  return function(d) { return "Παιδί " + d["0"] + ", η ηλικία " + d["1"] + " ενημερώθηκε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2042008928 = messageFormatterFn((function(  ) {
  return function(d) { return "Παιδί " + d["0"] + ", η ηλικία " + d["1"] + " ενημερώθηκε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1550398856 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση ενηλίκων από το δωμάτιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b333565822 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση παιδιών από το δωμάτιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1955794302 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση βρεφών από το δωμάτιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a366808776 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση ενηλίκων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b473936574 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση παιδιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1469212866 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση βρεφών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b117437012 = messageFormatterFn((function(  ) {
  return function(d) { return "Τέλος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1952287388 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη ενηλίκων στο δωμάτιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a839313758 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη παιδιών στο δωμάτιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a36248087 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη βρεφών στο δωμάτιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2039112612 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη ενηλίκων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a292281118 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη παιδιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b263501161 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη βρεφών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b524764759 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση δωματίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1427569457 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση δωματίου " + d["0"] + " από " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1193890263 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωμάτιο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1223050235 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωμάτιο " + d["0"] + " από " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b528336528 = messageFormatterFn((function(  ) {
  return function(d) { return "Προστέθηκε το δωμάτιο " + d["0"] + ". Επεξεργαστείτε τα στοιχεία των ταξιδιωτών παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1758384789 = messageFormatterFn((function(  ) {
  return function(d) { return "Το εργαλείο επιλογής ταξιδιώτη άνοιξε. Επεξεργαστείτε τα στοιχεία των ταξιδιωτών παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1857021552 = messageFormatterFn((function(  ) {
  return function(d) { return "Το δωμάτιο αφαιρέθηκε. Επεξεργαστείτε τα στοιχεία των ταξιδιωτών του δωματίου " + d["0"] + " παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a603783854 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάτω του 1 έτους"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1991396784 = messageFormatterFn((function(  ) {
  return function(d) { return "Εναλλαγή προέλευσης και προορισμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1716220046 = messageFormatterFn((function(  ) {
  return function(d) { return "Έγινε εναλλαγή προέλευσης και προορισμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1703802367 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε έναν προορισμό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1319426939 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε διαφορετικό προορισμό από την τοποθεσία προέλευσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a20665009 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορεί να γίνει κράτηση μόνο για 1-6 ταξιδιώτες για πακέτα. Προσαρμόστε τον αριθμό ταξιδιωτών της αναζήτησής σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a24713375 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορεί να γίνει κράτηση μόνο για 1 έως " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ταξιδιώτες";}, one: function() { return number(d["0"]) + " ταξιδιώτη";}, two: function() { return number(d["0"]) + " ταξιδιώτες";}, few: function() { return number(d["0"]) + " ταξιδιώτες";}, many: function() { return number(d["0"]) + " ταξιδιώτες";}, other: function() { return number(d["0"]) + " ταξιδιώτες";} }) + ". Προσαρμόστε τον αριθμό ταξιδιωτών της αναζήτησής σας."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b346679163 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιτρέπονται έως και 6 ταξιδιώτες ανά κράτηση."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b955987020 = messageFormatterFn((function(  ) {
  return function(d) { return "Πρέπει να υπάρχει τουλάχιστον 1 ταξιδιώτης (ηλικίας από " + d["0"] + " ετών και πάνω) για κάθε βρέφος στην αγκαλιά."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b279719257 = messageFormatterFn((function(  ) {
  return function(d) { return "Καταχωρίστε τις ηλικίες των παιδιών."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1447896055 = messageFormatterFn((function(  ) {
  return function(d) { return "Καταχωρίστε την ηλικία του παιδιού."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1126033330 = messageFormatterFn((function(  ) {
  return function(d) { return "Καταχωρίστε τις ηλικίες των βρεφών."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1421033065 = messageFormatterFn((function(  ) {
  return function(d) { return "Καταχωρίστε την ηλικία του βρέφους."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b349062099 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Λυπούμαστε, αλλά δεν μπορούν να υπάρχουν πάνω από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " βρέφη";}, one: function() { return number(d["0"]) + " βρέφος";}, two: function() { return number(d["0"]) + " βρέφη";}, few: function() { return number(d["0"]) + " βρέφη";}, many: function() { return number(d["0"]) + " βρέφη";}, other: function() { return number(d["0"]) + " βρέφη";} }) + " ανά ταξιδιώτη (ηλικίας από " + d["1"] + " ετών και πάνω) στην κράτησή σας."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1658604577 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1813461863 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1419979589 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1414493305 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a533047287 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση από"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1891988099 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση από"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1181073407 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a24898885 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιστροφή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b681117956 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε ημερομηνίες, για να δείτε τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a695360004 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε έναν προορισμό και ημερομηνίες για να δείτε τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1653022150 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε τις ημερομηνίες σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b920679211 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση από"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a333825206 = messageFormatterFn((function(  ) {
  return function(d) { return "Πόλη ή αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a560891365 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε ένα αεροδρόμιο προέλευσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1865165249 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση προς"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1104813310 = messageFormatterFn((function(  ) {
  return function(d) { return "Πόλη ή αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1208468325 = messageFormatterFn((function(  ) {
  return function(d) { return "Τύπος πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1239873075 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετ’ επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a864028614 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a592786207 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1620246993 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a477086215 = messageFormatterFn((function(  ) {
  return function(d) { return "Πρώτη θέση (First Class)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1508949352 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1094458696 = messageFormatterFn((function(  ) {
  return function(d) { return "Προτιμώμενη κατηγορία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2104727622 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε και κλείστε το εργαλείο επιλογής προτιμώμενης κατηγορίας χωρίς να αποθηκεύσετε τις αλλαγές. Εναλλακτικά, επιλέξτε άλλη προτιμώμενη κατηγορία παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a70544603 = messageFormatterFn((function(  ) {
  return function(d) { return "Πείτε μας από πού πετάτε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1845690493 = messageFormatterFn((function(  ) {
  return function(d) { return "Πείτε μας πού πετάτε."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b115215808 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη άλλης πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1700462117 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση σκέλους πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b858004201 = messageFormatterFn((function(  ) {
  return function(d) { return "Κανόνες ηλικίας αεροπορικής εταιρείας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1889031388 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού θα κάθεται το βρέφος;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a838005440 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού θα κάθονται τα βρέφη;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a924707656 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε θέση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1884596180 = messageFormatterFn((function(  ) {
  return function(d) { return "Στην αγκαλιά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1655643056 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση για ταξίδια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1866076493 = messageFormatterFn((function(  ) {
  return function(d) { return "Για συμβουλές για κρουαζιέρες από ειδικούς, καλέστε στο 1-888-444-1695."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a464017713 = messageFormatterFn((function(  ) {
  return function(d) { return "Όνομα καταλύματος, πόλη ή αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1532637782 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημιουργία ταξιδιού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1557802333 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε δύο ή περισσότερα στοιχεία:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1192079915 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε δύο ή περισσότερα στοιχεία, για να αρχίσετε να δημιουργείτε το ταξίδι σας:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b440684547 = messageFormatterFn((function(  ) {
  return function(d) { return "Διάρκεια διακοπών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b662254978 = messageFormatterFn((function(  ) {
  return function(d) { return "Προτιμώμενη κατηγορία θέσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1385091882 = messageFormatterFn((function(  ) {
  return function(d) { return "Χρειάζομαι κατάλυμα μόνο για ένα μέρος του ταξιδιού μου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a387937539 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε ένα ακόμη στοιχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1818680080 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε διαφορετικό συνδυασμό στοιχείων, για να αρχίσετε να δημιουργείτε το ταξίδι σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1671842910 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε δύο ή περισσότερα στοιχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a229992314 = messageFormatterFn((function(  ) {
  return function(d) { return "Για να αρχίσετε να δημιουργείτε το ταξίδι σας, επιλέξτε δύο ή περισσότερα στοιχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b814149224 = messageFormatterFn((function(  ) {
  return function(d) { return "Πακέτα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a382780234 = messageFormatterFn((function(  ) {
  return function(d) { return "Πακέτα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2111074676 = messageFormatterFn((function(  ) {
  return function(d) { return "Πόλη ή αξιοθέατο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2047070289 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορεί να γίνει κράτηση των πακέτων για πτήση και αυτοκίνητο μόνο με ένα κατάλυμα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a775693289 = messageFormatterFn((function(  ) {
  return function(d) { return "Απλή μετάβαση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a855271527 = messageFormatterFn((function(  ) {
  return function(d) { return "Διάφοροι προορισμοί"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1729572165 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b807627112 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1431945529 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση πτήσης " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1133275064 = messageFormatterFn((function(  ) {
  return function(d) { return "Η πτήση " + d["0"] + " έχει καταργηθεί"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b319631625 = messageFormatterFn((function(  ) {
  return function(d) { return "Παραλαβή και επιστροφή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1277795853 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία παραλαβής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1936264274 = messageFormatterFn((function(  ) {
  return function(d) { return "Ώρα παραλαβής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b896661377 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b45045248 = messageFormatterFn((function(  ) {
  return function(d) { return "Ώρα επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b246868957 = messageFormatterFn((function(  ) {
  return function(d) { return "Παραλαβή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a997301327 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιστροφή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1140393302 = messageFormatterFn((function(  ) {
  return function(d) { return "Γραφείο ενοικίασης αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a574386468 = messageFormatterFn((function(  ) {
  return function(d) { return "Τύπος έκπτωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a759526476 = messageFormatterFn((function(  ) {
  return function(d) { return "Συμπερίληψη τιμών μέλους AARP"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a336969108 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαιτείται ιδιότητα μέλους η οποία επαληθεύεται κατά την παραλαβή."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b756190592 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Οδηγός κάτω των " + d["0"] + " ή άνω των " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " ετών";}, one: function() { return number(d["1"]) + " έτους";}, two: function() { return number(d["1"]) + " ετών";}, few: function() { return number(d["1"]) + " ετών";}, many: function() { return number(d["1"]) + " ετών";}, other: function() { return number(d["1"]) + " ετών";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1752570209 = messageFormatterFn((function(  ) {
  return function(d) { return "Οι νεαρής ηλικίας ή οι ηλικιωμένοι οδηγοί ενδέχεται να απαιτείται να πληρώσουν επιπρόσθετο τέλος."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1950953269 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικία οδηγού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1790104284 = messageFormatterFn((function(  ) {
  return function(d) { return "Καταχωρίστε την ηλικία του οδηγού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b880241050 = messageFormatterFn((function(  ) {
  return function(d) { return "Θέλω να νοικιάσω αυτοκίνητο κάπου αλλού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2128305613 = messageFormatterFn((function(  ) {
  return function(d) { return "Όνομα ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1322578572 = messageFormatterFn((function(  ) {
  return function(d) { return "Όνομα καταλύματος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1422861214 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητάτε αθλητικές εκδηλώσεις, συναυλίες ή θεατρικές παραστάσεις;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1414305826 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητάτε αθλητικές εκδηλώσεις, συναυλίες ή φεστιβάλ μουσικής;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1276248876 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση εισιτηρίων εκδηλώσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1701704636 = messageFormatterFn((function(  ) {
  return function(d) { return "Τι μπορείτε να κάνετε σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a489444063 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1630627478 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη καταλύματος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1441938524 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1038876470 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a676141563 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b62665237 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1403744667 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1101914992 = messageFormatterFn((function(  ) {
  return function(d) { return "Μόνο απευθείας πτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1065919654 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορείτε να προσθέσετε πτήση ή ενοικίαση αυτοκινήτου, όταν κλείνετε έξι ή λιγότερα δωμάτια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1648743716 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορείτε να προσθέσετε πτήση ή ενοικίαση αυτοκινήτου, μόνο όταν οι ταξιδιώτες είναι 6 ή λιγότεροι"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a835327343 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση + ξενοδοχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b449921913 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση + ξενοδοχείο + αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1822901745 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση + αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1471445897 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχείο + αυτοκίνητο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b687125098 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b946692123 = messageFormatterFn((function(  ) {
  return function(d) { return "Χρειάζομαι ένα ξενοδοχείο μόνο για ένα μέρος της διαμονής μου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2129651121 = messageFormatterFn((function(  ) {
  return function(d) { return "Προέλευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1939137817 = messageFormatterFn((function(  ) {
  return function(d) { return "Προορισμός"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1956042008 = messageFormatterFn((function(  ) {
  return function(d) { return "Πόλη ή αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b605466256 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία αναχώρησης πρέπει να είναι μεταγενέστερη της ημερομηνίας αναχώρησης της προηγούμενης πτήσης σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a538660657 = messageFormatterFn((function(  ) {
  return function(d) { return "Φαίνεται ότι έχετε επιλέξει μόνο ένα προϊόν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b691641354 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε και άλλο προϊόν, για να αρχίσετε να δημιουργείτε το πακέτο διακοπών σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1634592644 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχετε επιλέξει πτήσεις και ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b159038586 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχετε επιλέξει πτήσεις, ξενοδοχεία και αυτοκίνητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b937414940 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχετε επιλέξει πτήσεις και αυτοκίνητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1680095434 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχετε επιλέξει ξενοδοχεία και αυτοκίνητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1440902238 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία check-in πρέπει να είναι ίδια με την ημερομηνία αναχώρησης ή μεταγενέστερη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1650393033 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ημερομηνία check-out πρέπει να είναι μεταγενέστερη από την ημερομηνία αναχώρησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1479607301 = messageFormatterFn((function(  ) {
  return function(d) { return "Το check-in σας πρέπει να πέφτει μέσα στις ημερομηνίες πρώτης αναχώρησης και τελευταίας επιστροφής σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1390949772 = messageFormatterFn((function(  ) {
  return function(d) { return "Το check-out σας πρέπει να πέφτει μέσα στις ημερομηνίες πρώτης αναχώρησης και τελευταίας επιστροφής σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2079495799 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε τις καλύτερες προσφορές για πακέτα και διακοπές all-inclusive."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a123608220 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση από"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1363895040 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε διάρκεια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b858872032 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσφορές με μεταφορά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2093302911 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Κράτηση για " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " άτομα";}, one: function() { return number(d["0"]) + " άτομο";}, two: function() { return number(d["0"]) + " άτομα";}, few: function() { return number(d["0"]) + " άτομα";}, many: function() { return number(d["0"]) + " άτομα";}, other: function() { return number(d["0"]) + " άτομα";} }) + " ή περισσότερα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1843721598 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση το νωρίτερο:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a795909047 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιστροφή το αργότερο:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1082502802 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση όλων των all-inclusive θερέτρων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a11927241 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαμονή σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1033516552 = messageFormatterFn((function(  ) {
  return function(d) { return "Όνομα ξενοδοχείου, πόλη ή αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1751225793 = messageFormatterFn((function(  ) {
  return function(d) { return "Θέλω να κλείσω διαμονή κάπου αλλού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b136342336 = messageFormatterFn((function(  ) {
  return function(d) { return "Από"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1142875001 = messageFormatterFn((function(  ) {
  return function(d) { return "Προς"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a878126922 = messageFormatterFn((function(  ) {
  return function(d) { return "Προορισμός, όνομα καταλύματος, αεροδρόμιο, σταθμός τρένου, σημείο ενδιαφέροντος ή διεύθυνση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1962870374 = messageFormatterFn((function(  ) {
  return function(d) { return "Προορισμός, όνομα καταλύματος ή σημείο ενδιαφέροντος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2126782169 = messageFormatterFn((function(  ) {
  return function(d) { return "Μεταφορά αεροδρομίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1172683807 = messageFormatterFn((function(  ) {
  return function(d) { return "Από το αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a307571058 = messageFormatterFn((function(  ) {
  return function(d) { return "Προς το αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2073354899 = messageFormatterFn((function(  ) {
  return function(d) { return "Από"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1628713820 = messageFormatterFn((function(  ) {
  return function(d) { return "Προς"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a311937284 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1978941329 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία άφιξης πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1513695282 = messageFormatterFn((function(  ) {
  return function(d) { return "Ώρα άφιξης πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b516614678 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία αναχώρησης πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b51368631 = messageFormatterFn((function(  ) {
  return function(d) { return "Ώρα αναχώρησης πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2063100658 = messageFormatterFn((function(  ) {
  return function(d) { return "Κράτηση μετ' επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1104192270 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτοκίνητα προς ενοικίαση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1509713401 = messageFormatterFn((function(  ) {
  return function(d) { return "Πόλη, αεροδρόμιο ή διεύθυνση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1018879565 = messageFormatterFn((function(  ) {
  return function(d) { return "Ίδια με τη διεύθυνση παραλαβής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a171655886 = messageFormatterFn((function(  ) {
  return function(d) { return "Προτιμώμενη επωνυμία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1520735837 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαθέτω κωδικό έκπτωσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1488341781 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλογή εταιρείας ενοικίασης αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1017364924 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσθήκη διαφορετικής τοποθεσίας επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1486886078 = messageFormatterFn((function(  ) {
  return function(d) { return "Ηλικία οδηγού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1319732459 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν έχω κωδικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b653902537 = messageFormatterFn((function(  ) {
  return function(d) { return "Εταιρική ή συμφωνημένη τιμή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a916226339 = messageFormatterFn((function(  ) {
  return function(d) { return "Ειδική ή διαφημιζόμενη τιμή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a770926498 = messageFormatterFn((function(  ) {
  return function(d) { return "Κωδικός εκπτωτικής τιμής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1449575192 = messageFormatterFn((function(  ) {
  return function(d) { return "Κωδικός εκπτωτικού κουπονιού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1415248899 = messageFormatterFn((function(  ) {
  return function(d) { return "Αρ. εταιρικής έκπτωσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b596434079 = messageFormatterFn((function(  ) {
  return function(d) { return "Κωδικός εταιρικής έκπτωσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b748438801 = messageFormatterFn((function(  ) {
  return function(d) { return "FASTSTART Org ID"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1015415948 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Alamo Insiders"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a219407045 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. AWD"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1544835992 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Wizard"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1101501606 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. BCD"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1087663994 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Fast Break"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b542492597 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Dollar Express"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1345185573 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. πελάτη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1299282122 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Enterprise Plus"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1415937807 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. σύμβασης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1321218984 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Privilege"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1986459427 = messageFormatterFn((function(  ) {
  return function(d) { return "CDP"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1904009325 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναγνωριστικό National Contract"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1351751133 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναγνωριστικό Emerald Club"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1482544220 = messageFormatterFn((function(  ) {
  return function(d) { return "Εταιρικός λογαριασμός"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1146960513 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Payless Perks"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b262136125 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθ. Blue Chip"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b724413045 = messageFormatterFn((function(  ) {
  return function(d) { return "ACE Rent A Car"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b536131341 = messageFormatterFn((function(  ) {
  return function(d) { return "Advantage Rent-A-Car"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1982250048 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamo Rent A Car"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1381769771 = messageFormatterFn((function(  ) {
  return function(d) { return "Avis"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1540615995 = messageFormatterFn((function(  ) {
  return function(d) { return "Budget"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2011297054 = messageFormatterFn((function(  ) {
  return function(d) { return "Dollar Rent A Car"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1278745478 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy Rent a Car"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b581960745 = messageFormatterFn((function(  ) {
  return function(d) { return "Enterprise"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1272594823 = messageFormatterFn((function(  ) {
  return function(d) { return "Europcar"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1792561170 = messageFormatterFn((function(  ) {
  return function(d) { return "Fox Rent a Car"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1784655113 = messageFormatterFn((function(  ) {
  return function(d) { return "Hertz"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b894647667 = messageFormatterFn((function(  ) {
  return function(d) { return "Midway Car Rental"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1733913442 = messageFormatterFn((function(  ) {
  return function(d) { return "National Car Rental"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1423848361 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu Car"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1525248413 = messageFormatterFn((function(  ) {
  return function(d) { return "Payless"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a554414789 = messageFormatterFn((function(  ) {
  return function(d) { return "Routes Car Rental"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b122886072 = messageFormatterFn((function(  ) {
  return function(d) { return "Sixt"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1651306866 = messageFormatterFn((function(  ) {
  return function(d) { return "Thrifty Car Rental"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1038199278 = messageFormatterFn((function(  ) {
  return function(d) { return "U-Save"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a153692844 = messageFormatterFn((function(  ) {
  return function(d) { return "Silvercar"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1341910133 = messageFormatterFn((function(  ) {
  return function(d) { return "Green Motion"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1249316669 = messageFormatterFn((function(  ) {
  return function(d) { return "NextCar"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b147099584 = messageFormatterFn((function(  ) {
  return function(d) { return "Rent-a-Wreck"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2041252034 = messageFormatterFn((function(  ) {
  return function(d) { return "Priceless"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b879314418 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a636133994 = messageFormatterFn((function(  ) {
  return function(d) { return "00:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1975201199 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b459752787 = messageFormatterFn((function(  ) {
  return function(d) { return "00:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b714994130 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a800454282 = messageFormatterFn((function(  ) {
  return function(d) { return "01:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1810880911 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b295432499 = messageFormatterFn((function(  ) {
  return function(d) { return "01:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b585911411 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a929537001 = messageFormatterFn((function(  ) {
  return function(d) { return "02:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1681798192 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b166349780 = messageFormatterFn((function(  ) {
  return function(d) { return "02:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b456828692 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1058619720 = messageFormatterFn((function(  ) {
  return function(d) { return "03:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1552715473 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b37267061 = messageFormatterFn((function(  ) {
  return function(d) { return "03:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b327745973 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1187702439 = messageFormatterFn((function(  ) {
  return function(d) { return "04:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1423632754 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a91815658 = messageFormatterFn((function(  ) {
  return function(d) { return "04:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b198663254 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1316785158 = messageFormatterFn((function(  ) {
  return function(d) { return "05:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1294550035 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a220898377 = messageFormatterFn((function(  ) {
  return function(d) { return "05:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b69580535 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1445867877 = messageFormatterFn((function(  ) {
  return function(d) { return "06:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1165467316 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a349981096 = messageFormatterFn((function(  ) {
  return function(d) { return "06:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a59502184 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1574950596 = messageFormatterFn((function(  ) {
  return function(d) { return "07:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1036384597 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a479063815 = messageFormatterFn((function(  ) {
  return function(d) { return "07:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a188584903 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1704033315 = messageFormatterFn((function(  ) {
  return function(d) { return "08:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b907301878 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a608146534 = messageFormatterFn((function(  ) {
  return function(d) { return "08:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a317667622 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1833116034 = messageFormatterFn((function(  ) {
  return function(d) { return "09:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b778219159 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a737229253 = messageFormatterFn((function(  ) {
  return function(d) { return "09:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1137479856 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a377968556 = messageFormatterFn((function(  ) {
  return function(d) { return "10:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2061600659 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b717918225 = messageFormatterFn((function(  ) {
  return function(d) { return "10:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1008397137 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a507051275 = messageFormatterFn((function(  ) {
  return function(d) { return "11:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2104283918 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b588835506 = messageFormatterFn((function(  ) {
  return function(d) { return "11:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2073639709 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b705879175 = messageFormatterFn((function(  ) {
  return function(d) { return "12:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a977752928 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1801765956 = messageFormatterFn((function(  ) {
  return function(d) { return "12:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2057007299 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b541558887 = messageFormatterFn((function(  ) {
  return function(d) { return "13:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1142073216 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1637445668 = messageFormatterFn((function(  ) {
  return function(d) { return "13:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1927924580 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b412476168 = messageFormatterFn((function(  ) {
  return function(d) { return "14:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1271155935 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1508362949 = messageFormatterFn((function(  ) {
  return function(d) { return "14:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1798841861 = messageFormatterFn((function(  ) {
  return function(d) { return "15:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b283393449 = messageFormatterFn((function(  ) {
  return function(d) { return "15:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1400238654 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1379280230 = messageFormatterFn((function(  ) {
  return function(d) { return "15:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1669759142 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b154310730 = messageFormatterFn((function(  ) {
  return function(d) { return "16:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1529321373 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1250197511 = messageFormatterFn((function(  ) {
  return function(d) { return "16:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1540676423 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b25228011 = messageFormatterFn((function(  ) {
  return function(d) { return "17:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1658404092 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1121114792 = messageFormatterFn((function(  ) {
  return function(d) { return "17:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1411593704 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a103854708 = messageFormatterFn((function(  ) {
  return function(d) { return "18:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1787486811 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b992032073 = messageFormatterFn((function(  ) {
  return function(d) { return "18:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1282510985 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a232937427 = messageFormatterFn((function(  ) {
  return function(d) { return "19:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1916569530 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b862949354 = messageFormatterFn((function(  ) {
  return function(d) { return "19:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1153428266 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a362020146 = messageFormatterFn((function(  ) {
  return function(d) { return "20:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2045652249 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b733866635 = messageFormatterFn((function(  ) {
  return function(d) { return "20:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1024345547 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a491102865 = messageFormatterFn((function(  ) {
  return function(d) { return "21:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2120232328 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b604783916 = messageFormatterFn((function(  ) {
  return function(d) { return "21:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1815474271 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b964044613 = messageFormatterFn((function(  ) {
  return function(d) { return "22:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a719587490 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2059931394 = messageFormatterFn((function(  ) {
  return function(d) { return "22:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1944556990 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b834961894 = messageFormatterFn((function(  ) {
  return function(d) { return "23:15"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a848670209 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1930848675 = messageFormatterFn((function(  ) {
  return function(d) { return "23:45"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1968595139 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a948353823 = messageFormatterFn((function(  ) {
  return function(d) { return "12:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2098684026 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1176041954 = messageFormatterFn((function(  ) {
  return function(d) { return "12:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1125819619 = messageFormatterFn((function(  ) {
  return function(d) { return "1:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a105578303 = messageFormatterFn((function(  ) {
  return function(d) { return "1:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1353507750 = messageFormatterFn((function(  ) {
  return function(d) { return "1:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a333266434 = messageFormatterFn((function(  ) {
  return function(d) { return "1:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a615285442 = messageFormatterFn((function(  ) {
  return function(d) { return "2:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b404955874 = messageFormatterFn((function(  ) {
  return function(d) { return "2:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a842973573 = messageFormatterFn((function(  ) {
  return function(d) { return "2:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b177267743 = messageFormatterFn((function(  ) {
  return function(d) { return "2:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a104751265 = messageFormatterFn((function(  ) {
  return function(d) { return "3:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b915490051 = messageFormatterFn((function(  ) {
  return function(d) { return "3:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a332439396 = messageFormatterFn((function(  ) {
  return function(d) { return "3:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b687801920 = messageFormatterFn((function(  ) {
  return function(d) { return "3:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b405782912 = messageFormatterFn((function(  ) {
  return function(d) { return "4:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1426024228 = messageFormatterFn((function(  ) {
  return function(d) { return "4:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b178094781 = messageFormatterFn((function(  ) {
  return function(d) { return "4:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1198336097 = messageFormatterFn((function(  ) {
  return function(d) { return "4:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b916317089 = messageFormatterFn((function(  ) {
  return function(d) { return "5:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1936558405 = messageFormatterFn((function(  ) {
  return function(d) { return "5:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b688628958 = messageFormatterFn((function(  ) {
  return function(d) { return "5:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1708870274 = messageFormatterFn((function(  ) {
  return function(d) { return "5:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1426851266 = messageFormatterFn((function(  ) {
  return function(d) { return "6:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1847874714 = messageFormatterFn((function(  ) {
  return function(d) { return "6:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1199163135 = messageFormatterFn((function(  ) {
  return function(d) { return "6:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2075562845 = messageFormatterFn((function(  ) {
  return function(d) { return "6:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1937385443 = messageFormatterFn((function(  ) {
  return function(d) { return "7:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1337340537 = messageFormatterFn((function(  ) {
  return function(d) { return "7:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1709697312 = messageFormatterFn((function(  ) {
  return function(d) { return "7:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1565028668 = messageFormatterFn((function(  ) {
  return function(d) { return "7:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1847047676 = messageFormatterFn((function(  ) {
  return function(d) { return "8:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a826806360 = messageFormatterFn((function(  ) {
  return function(d) { return "8:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2074735807 = messageFormatterFn((function(  ) {
  return function(d) { return "8:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1054494491 = messageFormatterFn((function(  ) {
  return function(d) { return "8:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1336513499 = messageFormatterFn((function(  ) {
  return function(d) { return "9:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a316272183 = messageFormatterFn((function(  ) {
  return function(d) { return "9:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1564201630 = messageFormatterFn((function(  ) {
  return function(d) { return "9:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a543960314 = messageFormatterFn((function(  ) {
  return function(d) { return "9:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1305303803 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1969422177 = messageFormatterFn((function(  ) {
  return function(d) { return "10:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1077615672 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2097856988 = messageFormatterFn((function(  ) {
  return function(d) { return "10:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1815837980 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1458888000 = messageFormatterFn((function(  ) {
  return function(d) { return "11:15 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1588149849 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1686576131 = messageFormatterFn((function(  ) {
  return function(d) { return "11:45 π.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1862517330 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a842276014 = messageFormatterFn((function(  ) {
  return function(d) { return "12:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2090205461 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1069964145 = messageFormatterFn((function(  ) {
  return function(d) { return "12:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1019741810 = messageFormatterFn((function(  ) {
  return function(d) { return "1:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b499506 = messageFormatterFn((function(  ) {
  return function(d) { return "1:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1247429941 = messageFormatterFn((function(  ) {
  return function(d) { return "1:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a227188625 = messageFormatterFn((function(  ) {
  return function(d) { return "1:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a509207633 = messageFormatterFn((function(  ) {
  return function(d) { return "2:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b511033683 = messageFormatterFn((function(  ) {
  return function(d) { return "2:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a736895764 = messageFormatterFn((function(  ) {
  return function(d) { return "2:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b283345552 = messageFormatterFn((function(  ) {
  return function(d) { return "2:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1326544 = messageFormatterFn((function(  ) {
  return function(d) { return "3:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1021567860 = messageFormatterFn((function(  ) {
  return function(d) { return "3:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a226361587 = messageFormatterFn((function(  ) {
  return function(d) { return "3:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b793879729 = messageFormatterFn((function(  ) {
  return function(d) { return "3:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b511860721 = messageFormatterFn((function(  ) {
  return function(d) { return "4:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1532102037 = messageFormatterFn((function(  ) {
  return function(d) { return "4:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b284172590 = messageFormatterFn((function(  ) {
  return function(d) { return "4:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1304413906 = messageFormatterFn((function(  ) {
  return function(d) { return "4:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1022394898 = messageFormatterFn((function(  ) {
  return function(d) { return "5:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2042636214 = messageFormatterFn((function(  ) {
  return function(d) { return "5:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b794706767 = messageFormatterFn((function(  ) {
  return function(d) { return "5:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1814948083 = messageFormatterFn((function(  ) {
  return function(d) { return "5:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1532929075 = messageFormatterFn((function(  ) {
  return function(d) { return "6:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1741796905 = messageFormatterFn((function(  ) {
  return function(d) { return "6:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1305240944 = messageFormatterFn((function(  ) {
  return function(d) { return "6:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1969485036 = messageFormatterFn((function(  ) {
  return function(d) { return "6:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2043463252 = messageFormatterFn((function(  ) {
  return function(d) { return "7:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1231262728 = messageFormatterFn((function(  ) {
  return function(d) { return "7:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1815775121 = messageFormatterFn((function(  ) {
  return function(d) { return "7:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1458950859 = messageFormatterFn((function(  ) {
  return function(d) { return "7:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1740969867 = messageFormatterFn((function(  ) {
  return function(d) { return "8:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a720728551 = messageFormatterFn((function(  ) {
  return function(d) { return "8:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1968657998 = messageFormatterFn((function(  ) {
  return function(d) { return "8:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a948416682 = messageFormatterFn((function(  ) {
  return function(d) { return "8:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1230435690 = messageFormatterFn((function(  ) {
  return function(d) { return "9:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a210194374 = messageFormatterFn((function(  ) {
  return function(d) { return "9:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1458123821 = messageFormatterFn((function(  ) {
  return function(d) { return "9:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a437882505 = messageFormatterFn((function(  ) {
  return function(d) { return "9:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1411381612 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1863344368 = messageFormatterFn((function(  ) {
  return function(d) { return "10:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1183693481 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2091032499 = messageFormatterFn((function(  ) {
  return function(d) { return "10:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1921915789 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1352810191 = messageFormatterFn((function(  ) {
  return function(d) { return "11:15 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1694227658 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1580498322 = messageFormatterFn((function(  ) {
  return function(d) { return "11:45 μ.μ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a59334611 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε μια ώρα παραλαβής μετά την τρέχουσα ώρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1670685697 = messageFormatterFn((function(  ) {
  return function(d) { return "Η επιλεγμένη ώρα είναι στο παρελθόν. Προσαρμόστε την επιλογή σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b103811360 = messageFormatterFn((function(  ) {
  return function(d) { return "Η πτήση αναχώρησης πρέπει να πραγματοποιείται τουλάχιστον 2 ώρες μετά την πτήση άφιξης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a329789988 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετάβαση σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a244993646 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση το νωρίτερο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a981954727 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση το αργότερο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b874035258 = messageFormatterFn((function(  ) {
  return function(d) { return "Ταξιδιώτες στην καμπίνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a398638377 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλογή προορισμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2062355084 = messageFormatterFn((function(  ) {
  return function(d) { return "Πιο δημοφιλείς"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1169312749 = messageFormatterFn((function(  ) {
  return function(d) { return "Καραϊβική"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a809104157 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπαχάμες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a443253985 = messageFormatterFn((function(  ) {
  return function(d) { return "Μεξικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1339959841 = messageFormatterFn((function(  ) {
  return function(d) { return "Αλάσκα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b538027826 = messageFormatterFn((function(  ) {
  return function(d) { return "Ευρώπη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2085959274 = messageFormatterFn((function(  ) {
  return function(d) { return "Βερμούδες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2007938033 = messageFormatterFn((function(  ) {
  return function(d) { return "Χαβάη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a196842467 = messageFormatterFn((function(  ) {
  return function(d) { return "Καναδάς/Νέα Αγγλία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1434012273 = messageFormatterFn((function(  ) {
  return function(d) { return "Άλλοι προορισμοί"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1682599229 = messageFormatterFn((function(  ) {
  return function(d) { return "Αρκτική/Ανταρκτική"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1094343458 = messageFormatterFn((function(  ) {
  return function(d) { return "Μέση Ανατολή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a681649574 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφρική"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b808664423 = messageFormatterFn((function(  ) {
  return function(d) { return "Κανάλι του Παναμά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a870612662 = messageFormatterFn((function(  ) {
  return function(d) { return "Ασία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a633263268 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακτή του Ειρηνικού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b351931881 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυστραλία/Νέα Ζηλανδία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1274907653 = messageFormatterFn((function(  ) {
  return function(d) { return "Κεντρική Αμερική"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1098831745 = messageFormatterFn((function(  ) {
  return function(d) { return "Γκαλαπάγκος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b240643974 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόδραση στη θάλασσα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1442243174 = messageFormatterFn((function(  ) {
  return function(d) { return "Διατλαντικά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b968667128 = messageFormatterFn((function(  ) {
  return function(d) { return "Παγκόσμια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1983341421 = messageFormatterFn((function(  ) {
  return function(d) { return "Νότια Αμερική"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a620476648 = messageFormatterFn((function(  ) {
  return function(d) { return "Νότιος Ειρηνικός"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a586000077 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαειρηνικά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1815761976 = messageFormatterFn((function(  ) {
  return function(d) { return "Λιμάνι αναχώρησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1190684866 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία απόπλου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b490149128 = messageFormatterFn((function(  ) {
  return function(d) { return "Διάρκεια ταξιδιού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1114783554 = messageFormatterFn((function(  ) {
  return function(d) { return "Εταιρεία κρουαζιερόπλοιων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1720967086 = messageFormatterFn((function(  ) {
  return function(d) { return "Το κατάλαβα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a459696309 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφία από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1161294893 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανοιχτά " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b698917189 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=\"" + d["0"] + "\">Φωτογραφία</a><span> από </span><a href=\"" + d["1"] + "\">" + d["2"] + "</a><span> (</span><a href=\"" + d["3"] + "\">" + d["4"] + "</a><span>)</span>"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1898819792 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=\"" + d["0"] + "\">Φωτογραφία</a> από " + d["1"] + " (<a href=\"" + d["2"] + "\">" + d["3"] + "</a>)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a798672478 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφία «" + d["0"] + "» από " + d["1"] + " (" + d["2"] + ") / Κομμένη από την πρωτότυπη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b16117976 = messageFormatterFn((function(  ) {
  return function(d) { return "Εκτιμώμενη τιμή για 1 διανυκτέρευση / 2 ενήλικες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1200512416 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1857658253 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφία για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a511391155 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάντε κράτηση τώρα, πληρώστε στο κατάλυμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1388837924 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1537451165 = messageFormatterFn((function(  ) {
  return function(d) { return "Με πλήρη επιστροφή χρημάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1307412515 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάντε κράτηση τώρα, πληρώστε στο κατάλυμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1998438956 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1080248130 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλα τα καταλύματα σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1143614097 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return "Δείτε " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " καταλύματα";}, one: function() { return d["1"] + " κατάλυμα";}, two: function() { return d["1"] + " καταλύματα";}, few: function() { return "all " + d["1"] + " καταλύματα";}, many: function() { return "all " + d["1"] + " καταλύματα";}, other: function() { return "all " + d["1"] + " καταλύματα";} }) + " στην τοποθεσία " + d["2"]; }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a136986127 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλα τα διαθέσιμα καταλύματα σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b703944389 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν βρήκατε αυτό που ψάχνετε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1800077616 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή όλων των καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b652177220 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b514174551 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b550817046 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα τύπου " + d["0"] + " σε " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1563069149 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχουμε και άλλα καταλύματα τύπου " + d["0"] + ". Βρείτε το ιδανικό για εσάς."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1133100800 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα all-inclusive καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a868363140 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα παραθαλάσσια καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a713174649 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα boutique καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1847675226 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα οικονομικά καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1608575787 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα business καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a848182794 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με καζίνο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1337789732 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα για οικογένειες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b645890722 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με γυμναστήριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1584999287 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με γκολφ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1905624261 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με κουζίνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1800156379 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με μικρή κουζίνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1899172130 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα πολυτελή καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1131557948 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με θέα στη θάλασσα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1786052629 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα που δέχονται κατοικίδια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a571525169 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με πισίνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1150786810 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα ρομαντικά καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1010685874 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα για σκι"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b182579771 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με σπα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1535282270 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με υδάτινο πάρκο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b205553035 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα καταλύματα με αίθουσα για γάμους"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1018243866 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία all-inclusive";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο all-inclusive";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία all-inclusive";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία all-inclusive";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία all-inclusive";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία all-inclusive";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b93452950 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη παραλιακά ξενοδοχεία";}, one: function() { return number(d["0"]) + " ακόμη παραλιακό ξενοδοχείο";}, two: function() { return number(d["0"]) + " ακόμη παραλιακά ξενοδοχεία";}, few: function() { return number(d["0"]) + " ακόμη παραλιακά ξενοδοχεία";}, many: function() { return number(d["0"]) + " ακόμη παραλιακά ξενοδοχεία";}, other: function() { return number(d["0"]) + " ακόμη παραλιακά ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1365691743 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη boutique ξενοδοχεία";}, one: function() { return number(d["0"]) + " ακόμη boutique ξενοδοχείο";}, two: function() { return number(d["0"]) + " ακόμη boutique ξενοδοχεία";}, few: function() { return number(d["0"]) + " ακόμη boutique ξενοδοχεία";}, many: function() { return number(d["0"]) + " ακόμη boutique ξενοδοχεία";}, other: function() { return number(d["0"]) + " ακόμη boutique ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1868867264 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη οικονομικά ξενοδοχεία";}, one: function() { return number(d["0"]) + " ακόμη οικονομικό ξενοδοχείο";}, two: function() { return number(d["0"]) + " ακόμη οικονομικά ξενοδοχεία";}, few: function() { return number(d["0"]) + " ακόμη οικονομικά ξενοδοχεία";}, many: function() { return number(d["0"]) + " ακόμη οικονομικά ξενοδοχεία";}, other: function() { return number(d["0"]) + " ακόμη οικονομικά ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a210620347 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη business ξενοδοχεία";}, one: function() { return number(d["0"]) + " ακόμη business ξενοδοχείο";}, two: function() { return number(d["0"]) + " ακόμη business ξενοδοχεία";}, few: function() { return number(d["0"]) + " ακόμη business ξενοδοχεία";}, many: function() { return number(d["0"]) + " ακόμη business ξενοδοχεία";}, other: function() { return number(d["0"]) + " ακόμη business ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a316669424 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με καζίνο";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με καζίνο";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με καζίνο";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με καζίνο";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με καζίνο";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με καζίνο";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1783331062 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για οικογένειες";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο για οικογένειες";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για οικογένειες";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για οικογένειες";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για οικογένειες";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για οικογένειες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1411329724 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γυμναστήριο";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με γυμναστήριο";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γυμναστήριο";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γυμναστήριο";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γυμναστήριο";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γυμναστήριο";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1290905693 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γκολφ";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με γκολφ";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γκολφ";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γκολφ";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γκολφ";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με γκολφ";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b441765973 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με κουζίνα";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με κουζίνα";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με κουζίνα";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με κουζίνα";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με κουζίνα";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με κουζίνα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a690345483 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με μικρή κουζίνα";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με μικρή κουζίνα";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με μικρή κουζίνα";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με μικρή κουζίνα";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με μικρή κουζίνα";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με μικρή κουζίνα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1974823176 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη πολυτελή ξενοδοχεία";}, one: function() { return number(d["0"]) + " ακόμη πολυτελές ξενοδοχείο";}, two: function() { return number(d["0"]) + " ακόμη πολυτελή ξενοδοχεία";}, few: function() { return number(d["0"]) + " ακόμη πολυτελή ξενοδοχεία";}, many: function() { return number(d["0"]) + " ακόμη πολυτελή ξενοδοχεία";}, other: function() { return number(d["0"]) + " ακόμη πολυτελή ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1879186006 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με θέα στη θάλασσα";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με θέα στη θάλασσα";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με θέα στη θάλασσα";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με θέα στη θάλασσα";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με θέα στη θάλασσα";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με θέα στη θάλασσα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a17379537 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία που δέχονται κατοικίδια";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο που δέχεται κατοικίδια";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία που δέχονται κατοικίδια";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία που δέχονται κατοικίδια";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία που δέχονται κατοικίδια";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία που δέχονται κατοικίδια";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a136748823 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με πισίνα";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με πισίνα";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με πισίνα";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με πισίνα";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με πισίνα";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με πισίνα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b482550036 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ρομαντικά ξενοδοχεία";}, one: function() { return number(d["0"]) + " ακόμη ρομαντικό ξενοδοχείο";}, two: function() { return number(d["0"]) + " ακόμη ρομαντικά ξενοδοχεία";}, few: function() { return number(d["0"]) + " ακόμη ρομαντικά ξενοδοχεία";}, many: function() { return number(d["0"]) + " ακόμη ρομαντικά ξενοδοχεία";}, other: function() { return number(d["0"]) + " ακόμη ρομαντικά ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1056423832 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για σκι";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο για σκι";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για σκι";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για σκι";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για σκι";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία για σκι";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2060236971 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με σπα";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με σπα";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με σπα";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με σπα";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με σπα";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με σπα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1892305800 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με υδάτινο πάρκο";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με υδάτινο πάρκο";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με υδάτινο πάρκο";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με υδάτινο πάρκο";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με υδάτινο πάρκο";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με υδάτινο πάρκο";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b205136549 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μπορείτε να επιλέξετε από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με αίθουσα για γάμους";}, one: function() { return number(d["0"]) + " ακόμη ξενοδοχείο με αίθουσα για γάμους";}, two: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με αίθουσα για γάμους";}, few: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με αίθουσα για γάμους";}, many: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με αίθουσα για γάμους";}, other: function() { return number(d["0"]) + " ακόμη ξενοδοχεία με αίθουσα για γάμους";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a741519642 = messageFormatterFn((function(  ) {
  return function(d) { return "Άνοιγμα της σελίδας " + d["0"] + " του ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1662316584 = messageFormatterFn((function(  ) {
  return function(d) { return "Για 2 επισκέπτες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1517334741 = messageFormatterFn((function(  ) {
  return function(d) { return "ανά διανυκτέρευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1930337906 = messageFormatterFn((function(  ) {
  return function(d) { return "Η τιμή είναι " + d["0"] + " ανά διανυκτέρευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b711872623 = messageFormatterFn((function(  ) {
  return function(d) { return "Η τιμή είναι " + d["0"] + " ανά διανυκτέρευση από " + d["1"] + " έως " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1514539319 = messageFormatterFn((function(  ) {
  return function(d) { return "Λήψη τιμών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1073580691 = messageFormatterFn((function(  ) {
  return function(d) { return "Το σχόλιο υποβλήθηκε στις " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1966977515 = messageFormatterFn((function(  ) {
  return function(d) { return "Καλό!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1966976554 = messageFormatterFn((function(  ) {
  return function(d) { return "Πολύ καλό!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1966975593 = messageFormatterFn((function(  ) {
  return function(d) { return "Άριστο!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1966974632 = messageFormatterFn((function(  ) {
  return function(d) { return "Θαυμάσιο!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1966973671 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξαιρετικό!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1894149906 = messageFormatterFn((function(  ) {
  return function(d) { return "Καλό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1894148945 = messageFormatterFn((function(  ) {
  return function(d) { return "Πολύ καλό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1894147984 = messageFormatterFn((function(  ) {
  return function(d) { return "Άριστο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1894147023 = messageFormatterFn((function(  ) {
  return function(d) { return "Θαυμάσιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1894146062 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξαιρετικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1318474390 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { 0: function() { return "Κανένα σχόλιο";}, zero: function() { return d["1"] + " σχόλια";}, one: function() { return d["1"] + " σχόλιο";}, two: function() { return d["1"] + " σχόλια";}, few: function() { return d["1"] + " σχόλια";}, many: function() { return d["1"] + " σχόλια";}, other: function() { return d["1"] + " σχόλια";} }); }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a875157904 = messageFormatterFn((function(  ) {
  return function(d) { return "Το " + d["0"] + " προστέθηκε στις λίστες σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b572906931 = messageFormatterFn((function(  ) {
  return function(d) { return "Αποθήκευση του " + d["0"] + " στις λίστες σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a148615002 = messageFormatterFn((function(  ) {
  return function(d) { return "Το " + d["0"] + " αφαιρέθηκε από τις λίστες σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b602197821 = messageFormatterFn((function(  ) {
  return function(d) { return "Αφαίρεση του " + d["0"] + " από τις λίστες σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a808526178 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Το συστήνουν " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ταξιδιώτες";}, one: function() { return number(d["0"]) + " ταξιδιώτης";}, two: function() { return number(d["0"]) + " ταξιδιώτες";}, few: function() { return number(d["0"]) + " ταξιδιώτες";}, many: function() { return number(d["0"]) + " ταξιδιώτες";}, other: function() { return number(d["0"]) + " ταξιδιώτες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1096796363 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " μίλια";}, one: function() { return d["1"] + " μίλι";}, two: function() { return d["1"] + " μίλια";}, few: function() { return d["1"] + " μίλια";}, many: function() { return d["1"] + " μίλια";}, other: function() { return d["1"] + " μίλια";} }) + " από " + d["2"]; }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1225998124 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " χλμ.";}, one: function() { return d["1"] + " χλμ.";}, two: function() { return d["1"] + " χλμ.";}, few: function() { return d["1"] + " χλμ.";}, many: function() { return d["1"] + " χλμ.";}, other: function() { return d["1"] + " χλμ.";} }) + " από " + d["2"]; }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1199389442 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " λεπτά";}, one: function() { return number(d["0"]) + " λεπτό";}, two: function() { return number(d["0"]) + " λεπτά";}, few: function() { return number(d["0"]) + " λεπτά";}, many: function() { return number(d["0"]) + " λεπτά";}, other: function() { return number(d["0"]) + " λεπτά";} }) + " με τα πόδια από " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b2087477207 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " λεπτά";}, one: function() { return number(d["0"]) + " λεπτό";}, two: function() { return number(d["0"]) + " λεπτά";}, few: function() { return number(d["0"]) + " λεπτά";}, many: function() { return number(d["0"]) + " λεπτά";}, other: function() { return number(d["0"]) + " λεπτά";} }) + " με το αυτοκίνητο από " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b610150887 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }) + " με το αυτοκίνητο από " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b268735954 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν βρέθηκαν αποτελέσματα σύμφωνα με τις επιλογές φίλτρου σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1578168152 = messageFormatterFn((function(  ) {
  return function(d) { return "Δοκιμάστε να προσαρμόσετε τα φίλτρα σας ή δείτε περισσότερες επιλογές παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2110369446 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε ημερομηνίες για να δείτε τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1477770312 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " χλμ.";}, one: function() { return d["1"] + " χλμ.";}, two: function() { return d["1"] + " χλμ.";}, few: function() { return d["1"] + " χλμ.";}, many: function() { return d["1"] + " χλμ.";}, other: function() { return d["1"] + " χλμ.";} }) + " από το κέντρο της πόλης"; }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1477714574 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " μίλια";}, one: function() { return d["1"] + " μίλι";}, two: function() { return d["1"] + " μίλια";}, few: function() { return d["1"] + " μίλια";}, many: function() { return d["1"] + " μίλια";}, other: function() { return d["1"] + " μίλια";} }) + " από το κέντρο της πόλης"; }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1986822132 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορεί να γίνει κράτηση για πακέτο πτήσης μόνο με μία διαμονή σε ξενοδοχείο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b182180301 = messageFormatterFn((function(  ) {
  return function(d) { return "Το κατάλαβα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1785163358 = messageFormatterFn((function(  ) {
  return function(d) { return "Χρειάζομαι πολλά μέρη για διαμονή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a76271217 = messageFormatterFn((function(  ) {
  return function(d) { return "Τιμές για κράτηση ξενοδοχείου μόνο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1166486823 = messageFormatterFn((function(  ) {
  return function(d) { return "Τιμές πακέτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a278495943 = messageFormatterFn((function(  ) {
  return function(d) { return "Νέα αγοραστική εμπειρία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2066929554 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε μια λίστα με όλα τα ξενοδοχεία εδώ (" + d["0"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1146323366 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε μια λίστα με όλα τα ξενοδοχεία κοντά σε: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a559329078 = messageFormatterFn((function(  ) {
  return function(d) { return "Προηγούμενο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b225585358 = messageFormatterFn((function(  ) {
  return function(d) { return "Επόμενο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1196379325 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή σε χάρτη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a855624631 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση χάρτη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1688109286 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Χάρτης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2124423732 = messageFormatterFn((function(  ) {
  return function(d) { return "Χάρτης ξενοδοχείων σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b146283440 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο χάρτη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a67455949 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { 0: function() { return "Κανένα σχόλιο";}, zero: function() { return d["1"] + " σχόλια";}, one: function() { return d["1"] + " σχόλιο";}, two: function() { return d["1"] + " σχόλια";}, few: function() { return d["1"] + " σχόλια";}, many: function() { return d["1"] + " σχόλια";}, other: function() { return d["1"] + " σχόλια";} }); }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1103042159 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " / 5"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b413570223 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε κοντινά καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a233471391 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση σε αυτή την περιοχή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1538900576 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν βρέθηκαν αποτελέσματα σύμφωνα με τις επιλογές φίλτρου σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b765384918 = messageFormatterFn((function(  ) {
  return function(d) { return "Δοκιμάστε να αλλάξετε τα φίλτρα σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1952640309 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτή η περιοχή δεν έχει διαθέσιμα καταλύματα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b824355083 = messageFormatterFn((function(  ) {
  return function(d) { return "Δοκιμάστε να μετακινήσετε τον χάρτη, για να επεκτείνετε την αναζήτησή σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a11689631 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + "<br />από " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1868427393 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + "\nαπό " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b472252686 = messageFormatterFn((function(  ) {
  return function(d) { return "Το σημάδι " + d["0"] + " δεν επιλέχθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a894099481 = messageFormatterFn((function(  ) {
  return function(d) { return "Το " + d["0"] + " σημάδι επιλέχθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b688909053 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " και " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b688910014 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " και " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b688910975 = messageFormatterFn((function(  ) {
  return function(d) { return d.zwsp + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1222257247 = messageFormatterFn((function(  ) {
  return function(d) { return "Λόγοι για να έρθετε εδώ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1212236236 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξερευνήστε την πόλη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a405017816 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ξενοδοχείων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1422842962 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοφιλείς πόλεις σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1971946995 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με κλιματισμό"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a255025663 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία all-inclusive";}, one: function() { return number(d["0"]) + " ξενοδοχείο all-inclusive";}, two: function() { return number(d["0"]) + " ξενοδοχεία all-inclusive";}, few: function() { return number(d["0"]) + " ξενοδοχεία all-inclusive";}, many: function() { return number(d["0"]) + " ξενοδοχεία all-inclusive";}, other: function() { return number(d["0"]) + " ξενοδοχεία all-inclusive";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1641420230 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με μπαλκόνι"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a879240293 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " παραλιακά ξενοδοχεία";}, one: function() { return number(d["0"]) + " παραλιακό ξενοδοχείο";}, two: function() { return number(d["0"]) + " παραλιακά ξενοδοχεία";}, few: function() { return number(d["0"]) + " παραλιακά ξενοδοχεία";}, many: function() { return number(d["0"]) + " παραλιακά ξενοδοχεία";}, other: function() { return number(d["0"]) + " παραλιακά ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a348884536 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " boutique ξενοδοχεία";}, one: function() { return number(d["0"]) + " boutique ξενοδοχείο";}, two: function() { return number(d["0"]) + " boutique ξενοδοχεία";}, few: function() { return number(d["0"]) + " boutique ξενοδοχεία";}, many: function() { return number(d["0"]) + " boutique ξενοδοχεία";}, other: function() { return number(d["0"]) + " boutique ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1116069027 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με πρωινό"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1403595751 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " οικονομικά ξενοδοχεία";}, one: function() { return number(d["0"]) + " οικονομικό ξενοδοχείο";}, two: function() { return number(d["0"]) + " οικονομικά ξενοδοχεία";}, few: function() { return number(d["0"]) + " οικονομικά ξενοδοχεία";}, many: function() { return number(d["0"]) + " οικονομικά ξενοδοχεία";}, other: function() { return number(d["0"]) + " οικονομικά ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b2137149548 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " business ξενοδοχεία";}, one: function() { return number(d["0"]) + " business ξενοδοχείο";}, two: function() { return number(d["0"]) + " business ξενοδοχεία";}, few: function() { return number(d["0"]) + " business ξενοδοχεία";}, many: function() { return number(d["0"]) + " business ξενοδοχεία";}, other: function() { return number(d["0"]) + " business ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a200557769 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία με καζίνο";}, one: function() { return number(d["0"]) + " ξενοδοχείο με καζίνο";}, two: function() { return number(d["0"]) + " ξενοδοχεία με καζίνο";}, few: function() { return number(d["0"]) + " ξενοδοχεία με καζίνο";}, many: function() { return number(d["0"]) + " ξενοδοχεία με καζίνο";}, other: function() { return number(d["0"]) + " ξενοδοχεία με καζίνο";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a399785775 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με υπηρεσία φροντίδας παιδιών"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a286611253 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με concierge"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1387519422 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με δωμάτια που επικοινωνούν εσωτερικά"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b755822237 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία για οικογένειες";}, one: function() { return number(d["0"]) + " ξενοδοχείο για οικογένειες";}, two: function() { return number(d["0"]) + " ξενοδοχεία για οικογένειες";}, few: function() { return number(d["0"]) + " ξενοδοχεία για οικογένειες";}, many: function() { return number(d["0"]) + " ξενοδοχεία για οικογένειες";}, other: function() { return number(d["0"]) + " ξενοδοχεία για οικογένειες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2045092287 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με γυμναστήριο"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a448898957 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με δωρεάν λεωφορειάκι μεταφοράς για αεροδρόμιο"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1140402703 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με δωρεάν πρωινό"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a634111822 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με δωρεάν στάθμευση"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1150903350 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία με γκολφ";}, one: function() { return number(d["0"]) + " ξενοδοχείο με γκολφ";}, two: function() { return number(d["0"]) + " ξενοδοχεία με γκολφ";}, few: function() { return number(d["0"]) + " ξενοδοχεία με γκολφ";}, many: function() { return number(d["0"]) + " ξενοδοχεία με γκολφ";}, other: function() { return number(d["0"]) + " ξενοδοχεία με γκολφ";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b96191576 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με τζακούζι"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a792083139 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με εσωτερική πισίνα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2115131558 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με κουζίνα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2048433798 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με μικρή κουζίνα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1386055648 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με εγκαταστάσεις πλυντηρίων"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1261593254 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με ήσυχο ποτάμι τεχνητής ροής"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b569457183 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " πολυτελή ξενοδοχεία";}, one: function() { return number(d["0"]) + " πολυτελές ξενοδοχείο";}, two: function() { return number(d["0"]) + " πολυτελή ξενοδοχεία";}, few: function() { return number(d["0"]) + " πολυτελή ξενοδοχεία";}, many: function() { return number(d["0"]) + " πολυτελή ξενοδοχεία";}, other: function() { return number(d["0"]) + " πολυτελή ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b416532929 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία μη καπνιστών";}, one: function() { return number(d["0"]) + " ξενοδοχείο μη καπνιστών";}, two: function() { return number(d["0"]) + " ξενοδοχεία μη καπνιστών";}, few: function() { return number(d["0"]) + " ξενοδοχεία μη καπνιστών";}, many: function() { return number(d["0"]) + " ξενοδοχεία μη καπνιστών";}, other: function() { return number(d["0"]) + " ξενοδοχεία μη καπνιστών";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1221313499 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία με θέα στη θάλασσα";}, one: function() { return number(d["0"]) + " ξενοδοχείο με θέα στη θάλασσα";}, two: function() { return number(d["0"]) + " ξενοδοχεία με θέα στη θάλασσα";}, few: function() { return number(d["0"]) + " ξενοδοχεία με θέα στη θάλασσα";}, many: function() { return number(d["0"]) + " ξενοδοχεία με θέα στη θάλασσα";}, other: function() { return number(d["0"]) + " ξενοδοχεία με θέα στη θάλασσα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b2021503334 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με εξωτερική πισίνα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b934576198 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με χώρο στάθμευσης"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2102214348 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία που δέχονται κατοικίδια";}, one: function() { return number(d["0"]) + " ξενοδοχείο που δέχεται κατοικίδια";}, two: function() { return number(d["0"]) + " ξενοδοχεία που δέχονται κατοικίδια";}, few: function() { return number(d["0"]) + " ξενοδοχεία που δέχονται κατοικίδια";}, many: function() { return number(d["0"]) + " ξενοδοχεία που δέχονται κατοικίδια";}, other: function() { return number(d["0"]) + " ξενοδοχεία που δέχονται κατοικίδια";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1408660848 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με πισίνα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a2068052659 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " στο ποτάμι"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a904911109 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ρομαντικά ξενοδοχεία";}, one: function() { return number(d["0"]) + " ρομαντικό ξενοδοχείο";}, two: function() { return number(d["0"]) + " ρομαντικά ξενοδοχεία";}, few: function() { return number(d["0"]) + " ρομαντικά ξενοδοχεία";}, many: function() { return number(d["0"]) + " ρομαντικά ξενοδοχεία";}, other: function() { return number(d["0"]) + " ρομαντικά ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a522711420 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με υπηρεσία δωματίου"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b506105261 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία για σκι";}, one: function() { return number(d["0"]) + " ξενοδοχείο για σκι";}, two: function() { return number(d["0"]) + " ξενοδοχεία για σκι";}, few: function() { return number(d["0"]) + " ξενοδοχεία για σκι";}, many: function() { return number(d["0"]) + " ξενοδοχεία για σκι";}, other: function() { return number(d["0"]) + " ξενοδοχεία για σκι";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b505963994 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία με σπα";}, one: function() { return number(d["0"]) + " ξενοδοχείο με σπα";}, two: function() { return number(d["0"]) + " ξενοδοχεία με σπα";}, few: function() { return number(d["0"]) + " ξενοδοχεία με σπα";}, many: function() { return number(d["0"]) + " ξενοδοχεία με σπα";}, other: function() { return number(d["0"]) + " ξενοδοχεία με σπα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1685440561 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με σουίτες"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1908474493 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία με υδάτινο πάρκο";}, one: function() { return number(d["0"]) + " ξενοδοχείο με υδάτινο πάρκο";}, two: function() { return number(d["0"]) + " ξενοδοχεία με υδάτινο πάρκο";}, few: function() { return number(d["0"]) + " ξενοδοχεία με υδάτινο πάρκο";}, many: function() { return number(d["0"]) + " ξενοδοχεία με υδάτινο πάρκο";}, other: function() { return number(d["0"]) + " ξενοδοχεία με υδάτινο πάρκο";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b359160306 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με νεροτσουλήθρες"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b2061102506 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " με αίθουσα για γάμους"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b156594907 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " 1 αστέρα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a730908774 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " 2 αστέρων"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1618412455 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " 3 αστέρων"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1789051160 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " 4 αστέρων"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b901547479 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }) + " 5 αστέρων"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1219309695 = messageFormatterFn((function(  ) {
  return function(d) { return "από <strong>" + d["0"] + "</strong>"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1928877990 = messageFormatterFn((function(  ) {
  return function(d) { return "από <span class=\"uitk-type-600 uitk-type-bold\">" + d["0"] + "</span>"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1851929085 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1401495653 = messageFormatterFn((function(  ) {
  return function(d) { return "ανά διανυκτέρευση/δωμάτιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a465034209 = messageFormatterFn((function(  ) {
  return function(d) { return "μόλις βρέθηκε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2054106745 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "βρέθηκε πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a152550107 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "βρέθηκε πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ημέρες";}, one: function() { return number(d["0"]) + " ημέρα";}, two: function() { return number(d["0"]) + " ημέρες";}, few: function() { return number(d["0"]) + " ημέρες";}, many: function() { return number(d["0"]) + " ημέρες";}, other: function() { return number(d["0"]) + " ημέρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b37918370 = messageFormatterFn((function(  ) {
  return function(d) { return "μετ' επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b628259196 = messageFormatterFn((function(  ) {
  return function(d) { return "ανά ημέρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b871517084 = messageFormatterFn((function(  ) {
  return function(d) { return "πτήση + ξενοδοχείο ανά άτομο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a426528383 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1899987417 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1676720543 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτοκίνητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1838683532 = messageFormatterFn((function(  ) {
  return function(d) { return "Διακοπές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a239007560 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενοικιαζόμενα για διακοπές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1165859652 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b111673863 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαβάστε περισσότερα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a817815613 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαβάστε λιγότερα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b593234527 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοφιλή αξιοθέατα σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b306187818 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοφιλή αξιοθέατα σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a926272602 = messageFormatterFn((function(  ) {
  return function(d) { return "Κορυφαίες δραστηριότητες σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1797526964 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Δείτε όλες τις δραστηριότητες σε αυτόν τον προορισμό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b538584930 = messageFormatterFn((function(  ) {
  return function(d) { return "Κορυφαία σημεία ενδιαφέροντος σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1250897965 = messageFormatterFn((function(  ) {
  return function(d) { return "Κορυφαία σημεία ενδιαφέροντος σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b281957036 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b262173780 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού να μείνετε: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2070382522 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Άλλες περιοχές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1843829322 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε ξενοδοχεία σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1305898486 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1304353598 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε ταξίδια ξενοδοχείο + πτήση σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1988207155 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε ξενοδοχεία σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b449775944 = messageFormatterFn((function(  ) {
  return function(d) { return "Φημίζεται για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b803643000 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε τον οδηγό μας «Πού να μείνετε»"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1383346325 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " σχόλια";}, one: function() { return d["1"] + " σχόλιο";}, two: function() { return d["1"] + " σχόλια";}, few: function() { return d["1"] + " σχόλια";}, many: function() { return d["1"] + " σχόλια";}, other: function() { return d["1"] + " σχόλια";} }); }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b146905835 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφίες από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1195670166 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφίες από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b848320013 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο συλλογής μικρογραφιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1580906408 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητήστε κοντινά ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a874383255 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείστε ένα εισιτήριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1625527166 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε ένα δωμάτιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a805350016 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο χάρτη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b458365800 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξερεύνηση χάρτη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b968156760 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο κάρτας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1709086660 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Εξερευνήστε την περιοχή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b335413800 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Εξερευνήστε σημεία ενδιαφέροντος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b263837855 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωμάτια από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1573355986 = messageFormatterFn((function(  ) {
  return function(d) { return "Τιμές από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b153799092 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφία: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b618136895 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόκομμα από το πρωτότυπο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b894302348 = messageFormatterFn((function(  ) {
  return function(d) { return "Περιλαμβάνεται πρωινό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a548831920 = messageFormatterFn((function(  ) {
  return function(d) { return "Επόμενο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a617531888 = messageFormatterFn((function(  ) {
  return function(d) { return "Προηγ."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1229963613 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή επόμενης εικόνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1298663581 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή προηγούμενης εικόνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1914616459 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο συλλογής φωτογραφιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a797078218 = messageFormatterFn((function(  ) {
  return function(d) { return "Συχνές ερωτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b207844418 = messageFormatterFn((function(  ) {
  return function(d) { return "Πόσο κοστίζει ένα ξενοδοχείο σε " + d["0"] + ";"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1958927898 = messageFormatterFn((function(  ) {
  return function(d) { return "Μήνας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a784343663 = messageFormatterFn((function(  ) {
  return function(d) { return "Τιμή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2017830755 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχεία 2 έως 4 αστέρων σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a116621771 = messageFormatterFn((function(  ) {
  return function(d) { return "Μέση τιμή με βάση " + d["0"] + " κρατήσεις στην " + d["1"] + " για 1 διανυκτέρευση, 2 ενήλικες."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1384221389 = messageFormatterFn((function(  ) {
  return function(d) { return "Μέση τιμή με βάση " + d["0"] + " κρατήσεις σε ξενοδοχεία 2 έως 4 αστέρων στην " + d["1"] + " για 1 διανυκτέρευση, 2 ενήλικες."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1901096049 = messageFormatterFn((function(  ) {
  return function(d) { return "Όλες οι τιμές εμφανίζονται σε " + d["0"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b576390804 = messageFormatterFn((function(  ) {
  return function(d) { return "* Δεν υπάρχουν διαθέσιμα δεδομένα τιμών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b73967301 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν υπάρχουν δεδομένα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1207621075 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή λίστας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b765293342 = messageFormatterFn((function(  ) {
  return function(d) { return "Πόσο κοστίζει η διαμονή σε " + d["0"] + ";"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b681620955 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Τελευταία κράτηση: Πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " λεπτά";}, one: function() { return number(d["0"]) + " λεπτό";}, two: function() { return number(d["0"]) + " λεπτά";}, few: function() { return number(d["0"]) + " λεπτά";}, many: function() { return number(d["0"]) + " λεπτά";}, other: function() { return number(d["0"]) + " λεπτά";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b251146475 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Τελευταία κράτηση: Πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a958386513 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b671841495 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόρριψη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b686536585 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαλοιφή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a410180256 = messageFormatterFn((function(  ) {
  return function(d) { return "Άλλες πόλεις όπως: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1700987011 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Διαβάστε ταξιδιωτικούς οδηγούς και συμβουλές για αυτό το μέρος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a222681790 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Εμφάνιση " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " φωτογραφιών";}, one: function() { return number(d["0"]) + " φωτογραφίας";}, two: function() { return number(d["0"]) + " φωτογραφιών";}, few: function() { return number(d["0"]) + " φωτογραφιών";}, many: function() { return number(d["0"]) + " φωτογραφιών";}, other: function() { return number(d["0"]) + " φωτογραφιών";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1142357388 = messageFormatterFn((function(  ) {
  return function(d) { return "Επισκόπηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b161288354 = messageFormatterFn((function(  ) {
  return function(d) { return "Βίντεο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a836739102 = messageFormatterFn((function(  ) {
  return function(d) { return "Πού να μείνετε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2141371950 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b104753954 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1217676034 = messageFormatterFn((function(  ) {
  return function(d) { return "Σχόλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b635383180 = messageFormatterFn((function(  ) {
  return function(d) { return "Blog"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a196713299 = messageFormatterFn((function(  ) {
  return function(d) { return "Παρόμοιοι προορισμοί"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b955405316 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανακαλύψτε: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b741058156 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Οδηγός ταξιδιού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b310468764 = messageFormatterFn((function(  ) {
  return function(d) { return "Κορυφαία αξιοθέατα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2015670327 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοφιλείς δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1803785779 = messageFormatterFn((function(  ) {
  return function(d) { return "Τύποι δραστηριοτήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a489335365 = messageFormatterFn((function(  ) {
  return function(d) { return "Η χαμηλότερη τιμή διανυκτέρευσης που βρέθηκε τις τελευταίες 24 ώρες με βάση τη διαμονή 1 διανυκτέρευσης για 2 ενήλικες. Οι τιμές και η διαθεσιμότητα υπόκεινται σε αλλαγές. Ενδέχεται να ισχύουν επιπρόσθετοι όροι."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2064826276 = messageFormatterFn((function(  ) {
  return function(d) { return "Έλεγχος διαθεσιμότητας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1830744332 = messageFormatterFn((function(  ) {
  return function(d) { return "Αύξηση τιμής από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b523508456 = messageFormatterFn((function(  ) {
  return function(d) { return "Μείωση τιμής από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a139700583 = messageFormatterFn((function(  ) {
  return function(d) { return "Sold out"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a439834865 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλες τις πρόσφατες αναζητήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a497829694 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα μπορούσατε να έχετε πρόσβαση σε χαμηλότερες τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1587960880 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξοικονομήστε κατά μέσο όρο " + d["0"] + "% σε χιλιάδες ξενοδοχεία όταν συνδεθείτε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a466140924 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξοικονομήστε " + d["0"] + "% ή περισσότερα σε χιλιάδες ξενοδοχεία όταν συνδεθείτε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1994274888 = messageFormatterFn((function(  ) {
  return function(d) { return "Με τις τιμές μελών, θα μπορούσατε να εξοικονομήσετε άμεσα 10% ή και παραπάνω σε χιλιάδες καταλύματα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a434272936 = messageFormatterFn((function(  ) {
  return function(d) { return "Εγγραφείτε, είναι δωρεάν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a627852932 = messageFormatterFn((function(  ) {
  return function(d) { return "Σύνδεση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1141210462 = messageFormatterFn((function(  ) {
  return function(d) { return "Δε βλέπετε αυτό που ψάχνετε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1462791580 = messageFormatterFn((function(  ) {
  return function(d) { return "Δοκιμάστε να ταξινομήσετε τα αποτελέσματα χρησιμοποιώντας αυτές τις επιλογές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b256559724 = messageFormatterFn((function(  ) {
  return function(d) { return "Ιανουάριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1101256470 = messageFormatterFn((function(  ) {
  return function(d) { return "Φεβρουάριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b67552211 = messageFormatterFn((function(  ) {
  return function(d) { return "Μάρτιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b715387280 = messageFormatterFn((function(  ) {
  return function(d) { return "Απρίλιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1233411569 = messageFormatterFn((function(  ) {
  return function(d) { return "Μάιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b92049866 = messageFormatterFn((function(  ) {
  return function(d) { return "Ιούνιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1096482292 = messageFormatterFn((function(  ) {
  return function(d) { return "Ιούλιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b662601545 = messageFormatterFn((function(  ) {
  return function(d) { return "Αύγουστο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1290967749 = messageFormatterFn((function(  ) {
  return function(d) { return "Σεπτέμβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b333432822 = messageFormatterFn((function(  ) {
  return function(d) { return "Οκτώβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1188858022 = messageFormatterFn((function(  ) {
  return function(d) { return "Νοέμβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1930420839 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεκέμβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1599647771 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφία που παρέχεται από " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1183344872 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαμονές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2014183155 = messageFormatterFn((function(  ) {
  return function(d) { return "Καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b406048764 = messageFormatterFn((function(  ) {
  return function(d) { return "Πακέτα διακοπών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2130409032 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτοκίνητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1647507472 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a840632588 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1940442323 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1646506924 = messageFormatterFn((function(  ) {
  return function(d) { return "Γκρουπ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1967673901 = messageFormatterFn((function(  ) {
  return function(d) { return "Μεταφορές αεροδρομίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1819221564 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενοικιαζόμενες κατοικίες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a565029735 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενοικιαζόμενες κατοικίες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1539631829 = messageFormatterFn((function(  ) {
  return function(d) { return "Διακοπές all-inclusive"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1251927787 = messageFormatterFn((function(  ) {
  return function(d) { return "Κρουαζιέρες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1033521701 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " από " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1497128826 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1444712045 = messageFormatterFn((function(  ) {
  return function(d) { return "Luxury Hotels and Resorts Collection"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1470592219 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχετε κάποιον προορισμό κατά νου;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b876656245 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάντε πιο συγκεκριμένη την αναζήτησή σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a220165462 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ξενοδοχείων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1288461383 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοφιλή φίλτρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b44414635 = messageFormatterFn((function(  ) {
  return function(d) { return "Σύνθετες επιλογές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a900253941 = messageFormatterFn((function(  ) {
  return function(d) { return "Επαγγελματικά ταξίδια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a594407961 = messageFormatterFn((function(  ) {
  return function(d) { return "Για οικογένειες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1624016242 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a764937829 = messageFormatterFn((function(  ) {
  return function(d) { return "Περιλαμβάνεται πρωινό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a589334716 = messageFormatterFn((function(  ) {
  return function(d) { return "Επαληθευμένος ταξιδιώτης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b630699491 = messageFormatterFn((function(  ) {
  return function(d) { return "Άριστο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b630700452 = messageFormatterFn((function(  ) {
  return function(d) { return "Καλό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b630701413 = messageFormatterFn((function(  ) {
  return function(d) { return "Ικανοποιητικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b630702374 = messageFormatterFn((function(  ) {
  return function(d) { return "Απογοητευτικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b630703335 = messageFormatterFn((function(  ) {
  return function(d) { return "Απαίσιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1140632193 = messageFormatterFn((function(  ) {
  return function(d) { return "Σχόλια για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1679676512 = messageFormatterFn((function(  ) {
  return function(d) { return "Κορυφαίος προορισμός"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a381355428 = messageFormatterFn((function(  ) {
  return function(d) { return "Βαθμολογία πελατών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1462347146 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " σχόλια";}, one: function() { return d["1"] + " σχόλιο";}, two: function() { return d["1"] + " σχόλια";}, few: function() { return d["1"] + " σχόλια";}, many: function() { return d["1"] + " σχόλια";}, other: function() { return d["1"] + " σχόλια";} }); }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a904758481 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return "Δείτε " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " σχόλια";}, one: function() { return d["1"] + " σχόλιο";}, two: function() { return d["1"] + " σχόλια";}, few: function() { return "και τα " + d["1"] + " σχόλια";}, many: function() { return "και τα " + d["1"] + " σχόλια";}, other: function() { return "και τα " + d["1"] + " σχόλια";} }) + " για " + d["2"]; }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a652237721 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b789137248 = messageFormatterFn((function(  ) {
  return function(d) { return "λιγότερο από μία ώρα πριν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1521123617 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return "μία ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1533235199 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ημέρες";}, one: function() { return "μία ημέρα";}, two: function() { return number(d["0"]) + " ημέρες";}, few: function() { return number(d["0"]) + " ημέρες";}, many: function() { return number(d["0"]) + " ημέρες";}, other: function() { return number(d["0"]) + " ημέρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b269656271 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " εβδομάδες";}, one: function() { return "μία εβδομάδα";}, two: function() { return number(d["0"]) + " εβδομάδες";}, few: function() { return number(d["0"]) + " εβδομάδες";}, many: function() { return number(d["0"]) + " εβδομάδες";}, other: function() { return number(d["0"]) + " εβδομάδες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1303105819 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "πριν από " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " μήνες";}, one: function() { return "ένα μήνα";}, two: function() { return number(d["0"]) + " μήνες";}, few: function() { return number(d["0"]) + " μήνες";}, many: function() { return number(d["0"]) + " μήνες";}, other: function() { return number(d["0"]) + " μήνες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a982734317 = messageFormatterFn((function(  ) {
  return function(d) { return "πριν από 1 χρόνο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b982773023 = messageFormatterFn((function(  ) {
  return function(d) { return "πάνω από 1 χρόνο πριν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2132835579 = messageFormatterFn((function(  ) {
  return function(d) { return "Οργανώστε το ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a560279863 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }) + " με το αυτοκίνητο"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1211320097 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }) + ", " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " λεπτά";}, one: function() { return number(d["1"]) + " λεπτό";}, two: function() { return number(d["1"]) + " λεπτά";}, few: function() { return number(d["1"]) + " λεπτά";}, many: function() { return number(d["1"]) + " λεπτά";}, other: function() { return number(d["1"]) + " λεπτά";} }) + " με το αυτοκίνητο"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b946204857 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " λεπτά";}, one: function() { return number(d["0"]) + " λεπτό";}, two: function() { return number(d["0"]) + " λεπτά";}, few: function() { return number(d["0"]) + " λεπτά";}, many: function() { return number(d["0"]) + " λεπτά";}, other: function() { return number(d["0"]) + " λεπτά";} }) + " με το αυτοκίνητο"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1487425920 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "°C (μέση)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1487428803 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "°F (μέση)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1913057965 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/μέση τιμή ανά διανυκτέρευση ανά δωμάτιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1731138565 = messageFormatterFn((function(  ) {
  return function(d) { return "Αποδράσεις για σαββατοκύριακο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a312224356 = messageFormatterFn((function(  ) {
  return function(d) { return "Προτεινόμενοι προορισμοί με βάση τα ξενοδοχεία που έχετε προβάλει"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1411497316 = messageFormatterFn((function(  ) {
  return function(d) { return "Προορισμοί για εσάς"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1506324505 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Ιανουάριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1150109275 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Φεβρουάριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1559353344 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Μάρτιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1105124227 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Απρίλιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1826312994 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Μάιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a713445883 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Ιούνιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a713405521 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Ιούλιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b261889028 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Αύγουστο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1922691570 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Σεπτέμβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1904199459 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Οκτώβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a298644459 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Νοέμβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a109829662 = messageFormatterFn((function(  ) {
  return function(d) { return "Δύο διανυκτερεύσεις για δύο ταξιδιώτες κοντά σε " + d["0"] + " τον Δεκέμβριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1827340126 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1821534463 = messageFormatterFn((function(  ) {
  return function(d) { return "Πετάξτε μακριά, περιπλανηθείτε παντού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a269007657 = messageFormatterFn((function(  ) {
  return function(d) { return "Πετάξτε και ανακαλύψτε την επόμενη περιπέτειά σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a980952153 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαμονή σε ξενοδοχεία, ονειρεμένες αποδράσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1722557647 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε το τέλειο κατάλυμα για το επόμενο ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b233238850 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημιουργία πακέτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1266956058 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάντε κράτηση μαζί για πτήση, ξενοδοχείο ή αυτοκίνητο και μεγιστοποιήστε το κέρδος σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a206313360 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητήστε ενοικιαζόμενα αυτοκίνητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1781671352 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητήστε, συγκρίνετε και εξοικονομήστε με τα γραφεία ενοικίασης αυτοκινήτων που εμπιστεύεστε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2097480765 = messageFormatterFn((function(  ) {
  return function(d) { return "Αποδράστε με μια κρουαζιέρα και χαλαρώστε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1459372962 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες όπου και αν βρίσκεστε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1570802822 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανακαλύψτε συναρπαστικές εμπειρίες και δραστηριότητες για το επόμενο ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1328716299 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε και συγκρίνετε πτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1616713653 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητήστε, συγκρίνετε και κάντε κράτηση για πτήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b570704603 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε και κάντε κράτηση σε ένα ξενοδοχείο για το επόμενο ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a918614194 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξοικονομήστε με πακέτα διακοπών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1093350002 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημιουργήστε το δικό σας πακέτο διακοπών και εξοικονομήστε για το επόμενο ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1183116412 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε και συγκρίνετε ενοικιαζόμενα αυτοκίνητα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b120834748 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητήστε, συγκρίνετε και εξοικονομήστε με τις μεγαλύτερες εταιρείες στην ενοικίαση αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a294980431 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε και συγκρίνετε κρουαζιέρες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1664807250 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2082194194 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξερευνήστε και κάντε κράτηση σε δραστηριότητες για το επόμενο ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b15872182 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες σε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1680752777 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενοικίαση αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1890111849 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση καταλυμάτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b630205309 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2117341855 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση δραστηριοτήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1869575511 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση πακέτων διακοπών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1725441349 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέξτε δύο ή περισσότερα στοιχεία, για να αρχίσετε να δημιουργείτε το ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2117633999 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ενοικιαζόμενων κατοικιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1204166327 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b187904088 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κρουαζιέρων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1121316580 = messageFormatterFn((function(  ) {
  return function(d) { return "Περισσότερες πληροφορίες για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1281843533 = messageFormatterFn((function(  ) {
  return function(d) { return "Προτεινόμενα ξενοδοχεία σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b577673948 = messageFormatterFn((function(  ) {
  return function(d) { return "Προτεινόμενα ξενοδοχεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1438116816 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαμείνετε εδώ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1536367347 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/5 (" + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " σχόλια";}, one: function() { return number(d["1"]) + " σχόλιο";}, two: function() { return number(d["1"]) + " σχόλια";}, few: function() { return number(d["1"]) + " σχόλια";}, many: function() { return number(d["1"]) + " σχόλια";}, other: function() { return number(d["1"]) + " σχόλια";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1841058833 = messageFormatterFn((function(  ) {
  return function(d) { return "Νούμερο " + d["0"] + " για " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a254756703 = messageFormatterFn((function(  ) {
  return function(d) { return "Βίντεο για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b800628997 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>" + d["0"] + "%</b> των ταξιδιωτών προτείνουν"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a294600160 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανά ενήλικα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1371964424 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν έχετε ακόμη αποφασίσει πού να πάτε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1970034899 = messageFormatterFn((function(  ) {
  return function(d) { return "Στην παραλία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a417091018 = messageFormatterFn((function(  ) {
  return function(d) { return "Με την οικογένεια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1044456919 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε ρομαντικό προορισμό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2016599957 = messageFormatterFn((function(  ) {
  return function(d) { return "Στο βουνό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1749140155 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε ιστορικό προορισμό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a161092116 = messageFormatterFn((function(  ) {
  return function(d) { return "Σπα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a354806280 = messageFormatterFn((function(  ) {
  return function(d) { return "Γκολφ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b344547813 = messageFormatterFn((function(  ) {
  return function(d) { return "Καζίνο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1877521679 = messageFormatterFn((function(  ) {
  return function(d) { return "Υδάτινο πάρκο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b641297158 = messageFormatterFn((function(  ) {
  return function(d) { return "Τζακούζι"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a612563778 = messageFormatterFn((function(  ) {
  return function(d) { return "Πισίνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2137484471 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1949284288 = messageFormatterFn((function(  ) {
  return function(d) { return "Το επόμενο ταξίδι σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1323568185 = messageFormatterFn((function(  ) {
  return function(d) { return "Το ταξίδι σας σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a276657679 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαθέσιμες εκπτώσεις!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a200339317 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή ξενοδοχείων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b952830987 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαθέσιμες εκπτώσεις σε αυτοκίνητα!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1739973863 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξεκλειδώσατε έκπτωση έως και " + d["0"] + "% σε αυτοκίνητα, επειδή κάνατε κράτηση στην Expedia."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a740896335 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b261327147 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαθέσιμες εκπτώσεις σε ξενοδοχεία!"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b271845895 = messageFormatterFn((function(  ) {
  return function(d) { return "Ξεκλειδώσατε έκπτωση έως και " + d["0"] + "% σε ξενοδοχεία, επειδή κάνατε κράτηση στην Expedia."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b525319204 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>" + d["0"] + "</b> (" + d["1"] + ") <b>- " + d["2"] + "</b> (" + d["3"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1623195348 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " (" + d["1"] + ") - " + d["2"] + " (" + d["3"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1683765356 = messageFormatterFn((function(  ) {
  return function(d) { return "Όροι και προϋποθέσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a761680589 = messageFormatterFn((function(  ) {
  return function(d) { return "Δήλωση αποποίησης ευθύνης σχετικά με τις τιμές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b55010957 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1585061624 = messageFormatterFn((function(  ) {
  return function(d) { return "Η τιμή ήταν " + d["0"] + ". Η τιμή τώρα είναι " + d["1"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1660615814 = messageFormatterFn((function(  ) {
  return function(d) { return "Προσφορές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2063695144 = messageFormatterFn((function(  ) {
  return function(d) { return "Δυστυχώς αυτή η καμπάνια έχει λήξει"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b813244384 = messageFormatterFn((function(  ) {
  return function(d) { return "Περιηγηθείτε σε άλλες ταξιδιωτικές προσφορές μας και προτάσεις παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b127682049 = messageFormatterFn((function(  ) {
  return function(d) { return "Στις οικογένειες αρέσουν:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1993951641 = messageFormatterFn((function(  ) {
  return function(d) { return "Στους ταξιδιώτες αρέσουν:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1046167460 = messageFormatterFn((function(  ) {
  return function(d) { return "Ιδανικό για οικογένειες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1271792006 = messageFormatterFn((function(  ) {
  return function(d) { return "Ιδανικό για σαββατοκύριακο σε σπα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b627207766 = messageFormatterFn((function(  ) {
  return function(d) { return "Οι ταξιδιώτες δήλωσαν..."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b138966992 = messageFormatterFn((function(  ) {
  return function(d) { return "Φιλτράρισμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b402311769 = messageFormatterFn((function(  ) {
  return function(d) { return "Φιλτράρισμα κατά"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1564985231 = messageFormatterFn((function(  ) {
  return function(d) { return "Φιλτράρισμα και φίλτρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1514347657 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε περισσότερα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1552168773 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε λιγότερα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a418012362 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση λιγότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1323786592 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1631637247 = messageFormatterFn((function(  ) {
  return function(d) { return "Λήψη τιμών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b550477109 = messageFormatterFn((function(  ) {
  return function(d) { return "Συνέχιση σχεδιασμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b607411977 = messageFormatterFn((function(  ) {
  return function(d) { return "ανά ταξιδιώτη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a392658117 = messageFormatterFn((function(  ) {
  return function(d) { return "ανά άτομο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1685707869 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Εξερευνήστε παρόμοια ξενοδοχεία " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " αστέρων";}, one: function() { return number(d["0"]) + " αστέρα";}, two: function() { return number(d["0"]) + " αστέρων";}, few: function() { return number(d["0"]) + " αστέρων";}, many: function() { return number(d["0"]) + " αστέρων";}, other: function() { return number(d["0"]) + " αστέρων";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b457532727 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Πολλά ξενοδοχεία " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " αστέρων";}, one: function() { return number(d["0"]) + " αστέρα";}, two: function() { return number(d["0"]) + " αστέρων";}, few: function() { return number(d["0"]) + " αστέρων";}, many: function() { return number(d["0"]) + " αστέρων";}, other: function() { return number(d["0"]) + " αστέρων";} }) + " έχουν τις ίδιες παροχές με ξενοδοχεία " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " αστέρων";}, one: function() { return number(d["1"]) + " αστέρα";}, two: function() { return number(d["1"]) + " αστέρων";}, few: function() { return number(d["1"]) + " αστέρων";}, many: function() { return number(d["1"]) + " αστέρων";}, other: function() { return number(d["1"]) + " αστέρων";} }) + ". Δείτε όλα τα ξενοδοχεία " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " αστέρων";}, one: function() { return number(d["0"]) + " αστέρα";}, two: function() { return number(d["0"]) + " αστέρων";}, few: function() { return number(d["0"]) + " αστέρων";}, many: function() { return number(d["0"]) + " αστέρων";}, other: function() { return number(d["0"]) + " αστέρων";} }) + " σε " + d["2"] + "."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1969107462 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακόμη δε βρήκατε αυτό που ψάχνετε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1094469326 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλα τα καταλύματα σε " + d["0"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1126454414 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορείτε επίσης να χρησιμοποιήσετε αυτά τα δημοφιλή φίλτρα, για να κάνετε πιο συγκεκριμένη την αναζήτησή σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a137757394 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return "Κατάλυμα " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return d["1"] + " αστέρων";}, one: function() { return d["1"] + " αστέρα";}, two: function() { return d["1"] + " αστέρων";}, few: function() { return d["1"] + " αστέρων";}, many: function() { return d["1"] + " αστέρων";}, other: function() { return d["1"] + " αστέρων";} }); }
})(messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b153257156 = messageFormatterFn((function(  ) {
  return function(d) { return "Απευθείας μετ' επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a759569521 = messageFormatterFn((function(  ) {
  return function(d) { return "Μετ’ επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1027498035 = messageFormatterFn((function(  ) {
  return function(d) { return "Απευθείας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b562616519 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Διαμονή " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " διανυκτερεύσεων";}, one: function() { return number(d["0"]) + " διανυκτέρευσης";}, two: function() { return number(d["0"]) + " διανυκτερεύσεων";}, few: function() { return number(d["0"]) + " διανυκτερεύσεων";}, many: function() { return number(d["0"]) + " διανυκτερεύσεων";}, other: function() { return number(d["0"]) + " διανυκτερεύσεων";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b890032031 = messageFormatterFn((function(  ) {
  return function(d) { return "Αγοράστε αυτό το πακέτο πτήσης και ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b757394917 = messageFormatterFn((function(  ) {
  return function(d) { return "Περιλαμβάνει " + d["0"] + " και " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a568055477 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Διαμονή " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " διανυκτερεύσεων";}, one: function() { return number(d["0"]) + " διανυκτέρευσης";}, two: function() { return number(d["0"]) + " διανυκτερεύσεων";}, few: function() { return number(d["0"]) + " διανυκτερεύσεων";}, many: function() { return number(d["0"]) + " διανυκτερεύσεων";}, other: function() { return number(d["0"]) + " διανυκτερεύσεων";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b229769907 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαβάστε την αποποίηση ευθύνης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b100779213 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλείσιμο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1530431327 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " (" + d["1"] + ") προς " + d["2"] + " (" + d["3"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1916288520 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξοικονομήστε " + d["0"] + "% στην πτήση σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1651843988 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξοικονομήστε " + d["0"] + "% στο αυτοκίνητό σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b5393316 = messageFormatterFn((function(  ) {
  return function(d) { return "Η τιμή ήταν " + d["0"] + ". Η τιμή τώρα είναι " + d["1"] + " ανά άτομο."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b889977254 = messageFormatterFn((function(  ) {
  return function(d) { return "Αγοράστε αυτό το πακέτο ξενοδοχείου και αυτοκινήτου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b805161641 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Μικρο-μεσαίο οικογενειακό αυτοκίνητο και διαμονή " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " διανυκτερεύσεων";}, one: function() { return number(d["0"]) + " διανυκτέρευσης";}, two: function() { return number(d["0"]) + " διανυκτερεύσεων";}, few: function() { return number(d["0"]) + " διανυκτερεύσεων";}, many: function() { return number(d["0"]) + " διανυκτερεύσεων";}, other: function() { return number(d["0"]) + " διανυκτερεύσεων";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1118996676 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλικ για ακύρωση: Το ξενοδοχείο που έχετε επιλέξει πληροί τις προϋποθέσεις για δωρεάν ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2022070298 = messageFormatterFn((function(  ) {
  return function(d) { return "Κλικ για ακύρωση: Η πτήση που έχετε επιλέξει πληροί τις προϋποθέσεις για δωρεάν ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2049948024 = messageFormatterFn((function(  ) {
  return function(d) { return "Αρ. δρομολογίου " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a750413322 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα σας δώσουμε τη δυνατότητα να ακυρώσετε την κράτησή σας δωρεάν πριν το check-in, ενώ θα επεξεργαστούμε την επιστροφή χρημάτων σας μέσω της αρχικής μεθόδου πληρωμής σας. Αν κάνετε κλικ στο παρακάτω κουμπί, θα ακυρώσουμε αυτόματα την κράτησή σας. Να θυμάστε ότι δε χρειάζεται να τηλεφωνήσετε για να επιβεβαιώσετε την ακύρωση. Είστε καλυμμένοι. Αν θέλετε να διατηρήσετε την κράτησή σας ή έχετε ήδη πραγματοποιήσει ακύρωση, απλώς κλείστε αυτήν τη σελίδα, χωρίς να κάνετε κλικ στο παρακάτω κουμπί."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1357022284 = messageFormatterFn((function(  ) {
  return function(d) { return "Η αεροπορική εταιρεία σάς δίνει τη δυνατότητα να ακυρώσετε την πτήση σας δωρεάν έως και 24 ώρες προτού ταξιδέψετε και θα σας δώσει πίστωση για χρήση σε μελλοντικές πτήσεις με αυτήν. Αν κάνετε κλικ στο παρακάτω κουμπί, θα ακυρώσουμε αυτόματα την πτήση σας. Να θυμάστε ότι δε χρειάζεται να τηλεφωνήσετε για να επιβεβαιώσετε την ακύρωση. Είστε καλυμμένοι. Αν θέλετε να διατηρήσετε την κράτησή σας ή έχετε ήδη πραγματοποιήσει ακύρωση, απλώς κλείστε αυτήν τη σελίδα, χωρίς να κάνετε κλικ στο παρακάτω κουμπί."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1954261100 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση κράτησης ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b24687771 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε την κράτησή σας στο ξενοδοχείο " + d["0"] + " έως τις " + d["1"] + " και λάβετε πλήρη επιστροφή χρημάτων."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b24686810 = messageFormatterFn((function(  ) {
  return function(d) { return "Αν πραγματοποιήσετε ακύρωση, θα εκδοθεί 100% επιστροφή χρημάτων στον αρχικό τύπο πληρωμής σας. Ενδέχεται να χρειαστούν έως και 30 ημέρες, για να λάβετε την επιστροφή χρημάτων σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b24685849 = messageFormatterFn((function(  ) {
  return function(d) { return "Θέλετε να ακυρώσετε την κράτησή σας;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b345365053 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέγοντας «Ναι, να γίνει ακύρωση της κράτησής μου», επιβεβαιώνω ότι θέλω να πραγματοποιήσω ακύρωση και δε θα χρεωθώ τέλη ακύρωσης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1515919400 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαβάστε τους όρους και προϋποθέσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1220092020 = messageFormatterFn((function(  ) {
  return function(d) { return "Ναι, να γίνει ακύρωση της κράτησής μου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1027542319 = messageFormatterFn((function(  ) {
  return function(d) { return "Όχι, να μη γίνει ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a629503474 = messageFormatterFn((function(  ) {
  return function(d) { return "Όροι και προϋποθέσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1991642281 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορείτε να ακυρώσετε την προπληρωμένη κράτηση ξενοδοχείου σας και δε θα χρεωθείτε κανένα τέλος ακύρωσης που αναφέρεται στους κανόνες και περιορισμούς για την κράτηση ξενοδοχείου."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1991643242 = messageFormatterFn((function(  ) {
  return function(d) { return "Αν δεν ακυρώσετε την κράτησή σας πριν την ημερομηνία ακύρωσης που αναφέρεται σε αυτό το μήνυμα, θα ισχύσει χρέωση ίση με τις ισχύουσες τιμές διανυκτέρευσης, τα τέλη ανάκτησης φόρου και τα τέλη παροχής υπηρεσιών."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1991644203 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενδέχεται να χρειαστούν έως και 30 ημέρες, για να εμφανιστεί η πίστωση στην κατάσταση κίνησης του λογαριασμού σας, ανάλογα με την τράπεζα που εξέδωσε την κάρτα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b143806959 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώσαμε την κράτησή σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b976662689 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα στείλουμε επιβεβαίωση στη διεύθυνση " + d["0"] + " εντός των επόμενων 14 ημερών. Ενδέχεται να χρειαστούν έως και 30 ημέρες, για να λάβετε την επιστροφή χρημάτων σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2039536589 = messageFormatterFn((function(  ) {
  return function(d) { return "Η κράτησή σας είναι ακόμη ενεργή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b139516287 = messageFormatterFn((function(  ) {
  return function(d) { return "Σας ευχαριστούμε που επιβεβαιώνετε ότι θέλετε να διατηρήσετε την κράτησή σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2130162978 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a438667415 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε την πτήση σας και εμείς θα σας δώσουμε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό της αρχικής τιμής του εισιτηρίου, για χρήση σε μελλοντική πτήση με την ίδια αεροπορική εταιρεία."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2079607477 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε την πτήση σας έως τις " + d["0"] + " και η αεροπορική εταιρεία θα σας δώσει πιστωτικές μονάδες που αντιστοιχούν στο ποσό της αρχικής τιμής του εισιτηρίου. Μπορείτε να χρησιμοποιήσετε αυτήν την πίστωση σε μελλοντική πτήση με την ίδια αεροπορική εταιρεία εντός 24 μηνών από την αρχική ημερομηνία αγοράς."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a438668376 = messageFormatterFn((function(  ) {
  return function(d) { return "Αν η αεροπορική εταιρεία έχει ήδη ακυρώσει την κράτησή σας, αγνοήστε αυτό το μήνυμα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a438669337 = messageFormatterFn((function(  ) {
  return function(d) { return "Θέλετε να ακυρώσετε την πτήση σας;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b555908271 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέγοντας «Ναι, να γίνει ακύρωση της πτήσης μου», επιβεβαιώνω ότι θέλω να πραγματοποιήσω ακύρωση και δε θα χρεωθώ τέλη ακύρωσης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b543898086 = messageFormatterFn((function(  ) {
  return function(d) { return "Ναι, να γίνει ακύρωση της πτήσης μου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1745836447 = messageFormatterFn((function(  ) {
  return function(d) { return "Όχι, να μη γίνει ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a585888287 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώσαμε την πτήση σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a885109946 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα στείλουμε email επιβεβαίωσης στη διεύθυνση " + d["0"] + " μέσα στις επόμενες εβδομάδες. Ενδέχεται να μην είναι δυνατό να απαντήσουμε πριν από την ημερομηνία αναχώρησή σας. Ωστόσο, μείνετε ήσυχοι ότι θα επεξεργαστούμε την ακύρωσή σας. Δεν απαιτείται καμία άλλη ενέργεια εκ μέρους σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a885110907 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα λάβετε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό της αρχικής τιμής του εισιτηρίου, για χρήση σε μελλοντική πτήση με την ίδια αεροπορική εταιρεία."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a885111868 = messageFormatterFn((function(  ) {
  return function(d) { return "Λόγω του πρωτοφανούς όγκου αναστατώσεων στα ταξίδια, ενδέχεται να χρειαστούν έως και 30 ημέρες για την επεξεργασία των πιστωτικών μονάδων αεροπορικής εταιρείας. Θα λάβετε άλλο email, όταν θα είναι διαθέσιμες οι πιστωτικές μονάδες αεροπορικής εταιρείας. Αυτό το email θα περιλαμβάνει το ποσό των πιστωτικών μονάδων αεροπορικής εταιρείας, την ημερομηνία λήξης, καθώς και πώς μπορείτε να τις χρησιμοποιήσετε σε μελλοντική πτήση."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1742606181 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν αλλάξαμε την κράτησή σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1923578547 = messageFormatterFn((function(  ) {
  return function(d) { return "Σας ευχαριστούμε που επιβεβαιώνετε ότι δεν θέλετε να ακυρώσουμε την πτήση σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1408630350 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση ή διατήρηση κράτησης ξενοδοχείου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1339272939 = messageFormatterFn((function(  ) {
  return function(d) { return "Εργαζόμαστε στενά με τους ταξιδιωτικούς συνεργάτες μας, για να σας προσφέρουμε ένα κουπόνι, αν αποφασίσετε να ακυρώσετε τη μη επιστρέψιμη κράτησή σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1339273900 = messageFormatterFn((function(  ) {
  return function(d) { return "Για να λάβετε κουπόνι, πρέπει να πραγματοποιήσετε ακύρωση έως τις " + d["0"] + ". Αυτό το κουπόνι θα έχει αξία ίση με το πλήρες ποσό της αρχικής τιμής αγοράς. Απλώς ενημερώστε μας αν θέλετε να ακυρώσετε ή να διατηρήσετε την κράτησή σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a213031238 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση κράτησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1615832245 = messageFormatterFn((function(  ) {
  return function(d) { return "Διατήρηση κράτησης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a548516939 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώσαμε την κράτησή σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1988297230 = messageFormatterFn((function(  ) {
  return function(d) { return "Η ενημέρωση θα εμφανιστεί στο δρομολόγιό σας μέσα στις επόμενες 72 ώρες. Έχετε υπόψη το εξής: Το δρομολόγιο δεν θα εμφανίζει το ποσό του κουπονιού."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1988298191 = messageFormatterFn((function(  ) {
  return function(d) { return "Λόγω του πρωτοφανούς όγκου αναστατώσεων στα ταξίδια, ενδέχεται να χρειαστούν έως και 30 ημέρες, για να λάβετε το κουπόνι σας. Δε θα λάβετε email, έως ότου το κουπόνι σας είναι έτοιμο. Δε χρειάζεται καμία άλλη ενέργεια εκ μέρους σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1988299152 = messageFormatterFn((function(  ) {
  return function(d) { return "Το κουπόνι ισχύει για ένα έτος από την ημερομηνία έκδοσης για μια νέα κράτηση στο ίδιο κατάλυμα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b562388551 = messageFormatterFn((function(  ) {
  return function(d) { return "Η κράτησή σας είναι ακόμη ενεργή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1030903559 = messageFormatterFn((function(  ) {
  return function(d) { return "Σας ευχαριστούμε που επιβεβαιώνετε ότι θέλετε να διατηρήσετε την κράτησή σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1688746676 = messageFormatterFn((function(  ) {
  return function(d) { return "Λυπούμαστε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a302996093 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b124233444 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε τις πτήσεις σας και εμείς θα σας δώσουμε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό των αρχικών τιμών των εισιτηρίων, για χρήση σε μελλοντικές πτήσεις με τις ίδιες αεροπορικές εταιρείες. Αν επιλέξετε να γίνει ακύρωση, θα ακυρώσουμε όλες τις ακόλουθες πτήσεις:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1142204318 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε τις πτήσεις σας και εμείς θα σας δώσουμε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό των αρχικών τιμών των εισιτηρίων, για χρήση σε μελλοντικές πτήσεις με την ίδια αεροπορική εταιρεία. Αν επιλέξετε να γίνει ακύρωση, θα ακυρώσουμε όλες τις ακόλουθες πτήσεις:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b124232483 = messageFormatterFn((function(  ) {
  return function(d) { return "Αν οι αεροπορικές εταιρείες έχουν ήδη ακυρώσει τις κρατήσεις σας, αγνοήστε αυτό το μήνυμα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1142203357 = messageFormatterFn((function(  ) {
  return function(d) { return "Αν η αεροπορική εταιρεία έχει ήδη ακυρώσει τις κρατήσεις σας, αγνοήστε αυτό το μήνυμα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b124231522 = messageFormatterFn((function(  ) {
  return function(d) { return "Θέλετε να ακυρώσετε τις πτήσεις σας;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b124230561 = messageFormatterFn((function(  ) {
  return function(d) { return "Έχετε υπόψη το εξής: Θα ακυρώσουμε όλες τις παραπάνω πτήσεις ταυτόχρονα. Δεν μπορούμε να ακυρώσουμε κάθε πτήση ξεχωριστά."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1911892140 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέγοντας «Ναι, να γίνει ακύρωση των πτήσεών μου», επιβεβαιώνω ότι θέλω να πραγματοποιήσω ακύρωση όλων των πτήσεών μου και δε θα χρεωθώ τέλη ακύρωσης."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a693388789 = messageFormatterFn((function(  ) {
  return function(d) { return "Ναι, να γίνει ακύρωση των πτήσεών μου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1506075066 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώσαμε τις πτήσεις σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1489068799 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα στείλουμε " + d["0"] + " email επιβεβαίωσης (ένα για κάθε σκέλος της πτήσης σας) στη διεύθυνση " + d["1"] + " μέσα στις επόμενες εβδομάδες. Ενδέχεται να μην είναι δυνατό να απαντήσουμε πριν από την ημερομηνία αναχώρησή σας. Ωστόσο, μείνετε ήσυχοι ότι θα επεξεργαστούμε την ακύρωσή σας. Δεν απαιτείται καμία άλλη ενέργεια εκ μέρους σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1489069760 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα λάβετε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό των αρχικών τιμών των εισιτηρίων, για χρήση σε μελλοντικές πτήσεις με τις ίδιες αεροπορικές εταιρείες."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a164032480 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα λάβετε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό των αρχικών τιμών των εισιτηρίων, για χρήση σε μελλοντικές πτήσεις με την ίδια αεροπορική εταιρεία."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1489070721 = messageFormatterFn((function(  ) {
  return function(d) { return "Λόγω του πρωτοφανούς όγκου αναστατώσεων στα ταξίδια, ενδέχεται να χρειαστούν έως και 30 ημέρες για την επεξεργασία των πιστωτικών μονάδων αεροπορικής εταιρείας. Θα λάβετε " + d["0"] + " επιπλέον email, όταν θα είναι διαθέσιμες οι πιστωτικές μονάδες αεροπορικής εταιρείας. Αυτά τα email θα περιλαμβάνουν το ποσό των πιστωτικών μονάδων αεροπορικής εταιρείας, τις ημερομηνίες λήξης, καθώς και πώς μπορείτε να τις χρησιμοποιήσετε σε μελλοντικές πτήσεις."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1946206292 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": " + d["1"] + " - " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a606496663 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση της πτήσης με " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a650113602 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε την πτήση σας με " + d["0"] + " και εμείς θα σας δώσουμε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό της αρχικής τιμής του εισιτηρίου, για χρήση σε μελλοντική πτήση με την " + d["0"] + ". Αν επιλέξετε να γίνει ακύρωση, θα ακυρώσουμε την ακόλουθη πτήση:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a650114563 = messageFormatterFn((function(  ) {
  return function(d) { return "Δυστυχώς, δεν μπορούμε να ακυρώσουμε την ακόλουθη πτήση. Για να ακυρώσετε αυτήν την πτήση, πρέπει να επικοινωνήσετε με την αεροπορική εταιρεία."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a650115524 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλέγοντας «Ναι, να γίνει ακύρωση της πτήσης μου με " + d["0"] + "», επιβεβαιώνω ότι θέλω να πραγματοποιήσω ακύρωση της πτήσης με " + d["0"] + " και δε θα χρεωθώ τέλη ακύρωσης. Επίσης, κατανοώ ότι πρέπει να ακυρώσω την πτήση μου " + d["1"] + " μέσω της αεροπορικής εταιρείας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a277558799 = messageFormatterFn((function(  ) {
  return function(d) { return "Ναι, να γίνει ακύρωση της πτήσης μου με " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1246327174 = messageFormatterFn((function(  ) {
  return function(d) { return "Όχι, να μη γίνει ακύρωση της πτήσης μου με " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1370710484 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώσαμε την πτήση σας με " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a780036389 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα στείλουμε email επιβεβαίωσης στη διεύθυνση " + d["0"] + " μέσα στις επόμενες εβδομάδες. Ενδέχεται να μην είναι δυνατό να απαντήσουμε πριν από την ημερομηνία αναχώρησή σας. Ωστόσο, μείνετε ήσυχοι ότι θα επεξεργαστούμε την ακύρωσή σας. Δεν απαιτείται καμία άλλη ενέργεια εκ μέρους σας."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a780037350 = messageFormatterFn((function(  ) {
  return function(d) { return "Θα λάβετε πιστωτικές μονάδες αεροπορικής εταιρείας που αντιστοιχούν στο ποσό της αρχικής τιμής του εισιτηρίου με " + d["0"] + ", για χρήση σε μελλοντικές πτήσεις με την " + d["0"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a780038311 = messageFormatterFn((function(  ) {
  return function(d) { return "Λόγω του πρωτοφανούς όγκου αναστατώσεων στα ταξίδια, ενδέχεται να χρειαστούν έως και 30 ημέρες για την επεξεργασία των πιστωτικών μονάδων αεροπορικής εταιρείας. Θα λάβετε ένα επιπλέον email, όταν θα είναι διαθέσιμες οι πιστωτικές μονάδες αεροπορικής εταιρείας. Αυτό το email θα περιλαμβάνει το ποσό των πιστωτικών μονάδων αεροπορικής εταιρείας, την ημερομηνία λήξης, καθώς και πώς μπορείτε να τις χρησιμοποιήσετε σε μελλοντική πτήση."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1107375030 = messageFormatterFn((function(  ) {
  return function(d) { return "Σύνδεσμος για τον οδηγό ταξιδιού για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1361617145 = messageFormatterFn((function(  ) {
  return function(d) { return "Σύνδεσμος για τον οδηγό ταξιδιού για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1172166644 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλα τα διαθέσιμα ταξίδια από " + d["0"] + " προς " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a193306442 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή όλων των ταξιδιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a539070751 = messageFormatterFn((function(  ) {
  return function(d) { return "Κάντε αίτηση τώρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1527658030 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή λεπτομερειών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a417886260 = messageFormatterFn((function(  ) {
  return function(d) { return "Γράφημα μόνο για λόγους απεικόνισης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a537050163 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση λεπτομερειών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1066705181 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση σχολίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1420407332 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιλογή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1427470222 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόκρυψη λεπτομερειών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1814065566 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόκρυψη σχολίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b46841045 = messageFormatterFn((function(  ) {
  return function(d) { return "Συγκατάθεση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1446245666 = messageFormatterFn((function(  ) {
  return function(d) { return "Άρνηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1235480360 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπορείτε επίσης να διαχειριστείτε τις προτιμήσεις σχετικά με τα cookies ανά πάσα στιγμή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b559732630 = messageFormatterFn((function(  ) {
  return function(d) { return "Οδηγός ταξιδιού για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a243225301 = messageFormatterFn((function(  ) {
  return function(d) { return "Οδηγός ταξιδιού για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1069113991 = messageFormatterFn((function(  ) {
  return function(d) { return "Οδηγός ταξιδιού για " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1090504798 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροδρόμιο προορισμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a303435418 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροδρόμιο προέλευσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a389133024 = messageFormatterFn((function(  ) {
  return function(d) { return "Τιμή μετ' επιστροφής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a105272097 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόσταση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1162389368 = messageFormatterFn((function(  ) {
  return function(d) { return "Όνομα πόλης προέλευσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a438932804 = messageFormatterFn((function(  ) {
  return function(d) { return "Όνομα πόλης προορισμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1177957211 = messageFormatterFn((function(  ) {
  return function(d) { return "Κωδικός ΙΑΤΑ αεροδρομίου προορισμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a989523265 = messageFormatterFn((function(  ) {
  return function(d) { return "Κωδικός ΙΑΤΑ αεροδρομίου προέλευσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1205740945 = messageFormatterFn((function(  ) {
  return function(d) { return "Δημοφιλής αεροπορική εταιρεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a54597252 = messageFormatterFn((function(  ) {
  return function(d) { return "Μέση διάρκεια πτήσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b865566743 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθμός αεροπορικών εταιρειών που πραγματοποιούν αυτό το δρομολόγιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b486697568 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθμός επιλογών πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1924801527 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροπορικές εταιρείες που πραγματοποιούν αυτό το δρομολόγιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b435096958 = messageFormatterFn((function(  ) {
  return function(d) { return "Πληροφορίες διαδρομής " + d["0"] + " προς " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a68295722 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }) + " " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " λεπτά";}, one: function() { return number(d["1"]) + " λεπτό";}, two: function() { return number(d["1"]) + " λεπτά";}, few: function() { return number(d["1"]) + " λεπτά";}, many: function() { return number(d["1"]) + " λεπτά";}, other: function() { return number(d["1"]) + " λεπτά";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1972651385 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1789376393 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " λεπτά";}, one: function() { return number(d["0"]) + " λεπτό";}, two: function() { return number(d["0"]) + " λεπτά";}, few: function() { return number(d["0"]) + " λεπτά";}, many: function() { return number(d["0"]) + " λεπτά";}, other: function() { return number(d["0"]) + " λεπτά";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a150598210 = messageFormatterFn((function(  ) {
  return function(d) { return "Κωδικός αεροδρομίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1973559424 = messageFormatterFn((function(  ) {
  return function(d) { return "Χώρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a452857696 = messageFormatterFn((function(  ) {
  return function(d) { return "Όνομα αεροδρομίου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b482392663 = messageFormatterFn((function(  ) {
  return function(d) { return "Αριθμός πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1741140476 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροδρόμια " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2066758586 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιβιβαστείτε σήμερα σε ένα αεροπλάνο της " + d["0"] + " και πετάξτε σε διάφορους προορισμούς από αυτά τα εγχώρια και διεθνή αεροδρόμια:"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2116183116 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροπορική εταιρεία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a125170028 = messageFormatterFn((function(  ) {
  return function(d) { return "Πτήση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a541017427 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1237150596 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναχώρηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1463245360 = messageFormatterFn((function(  ) {
  return function(d) { return "Άφιξη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1736997017 = messageFormatterFn((function(  ) {
  return function(d) { return "Άφιξη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a878649349 = messageFormatterFn((function(  ) {
  return function(d) { return "Στάσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a252985421 = messageFormatterFn((function(  ) {
  return function(d) { return "Έλεγχος ναύλου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a97466815 = messageFormatterFn((function(  ) {
  return function(d) { return "Τέρμιναλ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b108024176 = messageFormatterFn((function(  ) {
  return function(d) { return "Πύλη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b546243046 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν υπάρχουν διαθέσιμα δεδομένα αυτήν τη στιγμή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a838379836 = messageFormatterFn((function(  ) {
  return function(d) { return "Αυτήν τη στιγμή, δεν διαθέτουμε καταγραφές για αυτήν την πτήση τη συγκεκριμένη ημερομηνία."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a678256950 = messageFormatterFn((function(  ) {
  return function(d) { return "Δοκιμάστε ξανά αργότερα."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1222587574 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "ΣΥΝΟΛΙΚΟΣ ΧΡΟΝΟΣ: " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ώρες";}, one: function() { return number(d["0"]) + " ώρα";}, two: function() { return number(d["0"]) + " ώρες";}, few: function() { return number(d["0"]) + " ώρες";}, many: function() { return number(d["0"]) + " ώρες";}, other: function() { return number(d["0"]) + " ώρες";} }) + " " + plural(d["1"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["1"]) + " λεπτά";}, one: function() { return number(d["1"]) + " λεπτό";}, two: function() { return number(d["1"]) + " λεπτά";}, few: function() { return number(d["1"]) + " λεπτά";}, many: function() { return number(d["1"]) + " λεπτά";}, other: function() { return number(d["1"]) + " λεπτά";} }) + " | ΣΥΝΟΛΙΚΗ ΑΠΟΣΤΑΣΗ: " + d["2"] + " " + d["3"]; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b2017565800 = messageFormatterFn((function(  ) {
  return function(d) { return "Οι αναζητήσεις ταξιδιών παρέχονται από την Expedia."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2045683977 = messageFormatterFn((function(  ) {
  return function(d) { return "Τοποθεσία παραλαβής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1414157037 = messageFormatterFn((function(  ) {
  return function(d) { return "Δε βρήκατε αυτό που ψάχνετε;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1490016825 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλα τα ενοικιαζόμενα αυτοκίνητα σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2033160347 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή όλων των αυτοκινήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a171713739 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Οι χαμηλότερες τιμές που βρέθηκαν " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return "τις τελευταίες " + number(d["0"]) + " ημέρες";}, one: function() { return "την τελευταία ημέρα";}, two: function() { return "τις τελευταίες " + number(d["0"]) + " ημέρες";}, few: function() { return "τις τελευταίες " + number(d["0"]) + " ημέρες";}, many: function() { return "τις τελευταίες " + number(d["0"]) + " ημέρες";}, other: function() { return "τις τελευταίες " + number(d["0"]) + " ημέρες";} }) + ". Οι τιμές και η διαθεσιμότητα υπόκεινται σε αλλαγές. Ενδέχεται να ισχύουν επιπρόσθετοι όροι."; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a680366385 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Οι χαμηλότερες τιμές που βρέθηκαν " + plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return "τις τελευταίες " + number(d["0"]) + " ώρες";}, one: function() { return "την τελευταία ώρα";}, two: function() { return "τις τελευταίες " + number(d["0"]) + " ώρες";}, few: function() { return "τις τελευταίες " + number(d["0"]) + " ώρες";}, many: function() { return "τις τελευταίες " + number(d["0"]) + " ώρες";}, other: function() { return "τις τελευταίες " + number(d["0"]) + " ώρες";} }) + ". Οι τιμές και η διαθεσιμότητα υπόκεινται σε αλλαγές. Ενδέχεται να ισχύουν επιπρόσθετοι όροι. "; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b583014678 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " άτομα";}, one: function() { return number(d["0"]) + " άτομο";}, two: function() { return number(d["0"]) + " άτομα";}, few: function() { return number(d["0"]) + " άτομα";}, many: function() { return number(d["0"]) + " άτομα";}, other: function() { return number(d["0"]) + " άτομα";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b120756484 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ή παρόμοιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1096567078 = messageFormatterFn((function(  ) {
  return function(d) { return "ανά ημέρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2084090317 = messageFormatterFn((function(  ) {
  return function(d) { return "σύνολο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1876643737 = messageFormatterFn((function(  ) {
  return function(d) { return "Αεροδρόμιο " + d["0"] + " (" + d["1"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a839797491 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + ", " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1682722562 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1963505243 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"] + " από το κέντρο της πόλης " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1409031273 = messageFormatterFn((function(  ) {
  return function(d) { return "Απεριόριστα χιλιόμετρα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1842757154 = messageFormatterFn((function(  ) {
  return function(d) { return "Χιλιόμετρα με περιορισμό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b977938712 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν μίλια";}, one: function() { return number(d["0"]) + " δωρεάν μίλι";}, two: function() { return number(d["0"]) + " δωρεάν μίλια";}, few: function() { return number(d["0"]) + " δωρεάν μίλια";}, many: function() { return number(d["0"]) + " δωρεάν μίλια";}, other: function() { return number(d["0"]) + " δωρεάν μίλια";} }) + "/ημέρα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a775205038 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, one: function() { return number(d["0"]) + " δωρεάν χιλιόμετρο";}, two: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, few: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, many: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, other: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";} }) + "/ημέρα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1936598184 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν μίλια";}, one: function() { return number(d["0"]) + " δωρεάν μίλι";}, two: function() { return number(d["0"]) + " δωρεάν μίλια";}, few: function() { return number(d["0"]) + " δωρεάν μίλια";}, many: function() { return number(d["0"]) + " δωρεάν μίλια";}, other: function() { return number(d["0"]) + " δωρεάν μίλια";} }) + "/εβδομάδα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a449479586 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, one: function() { return number(d["0"]) + " δωρεάν χιλιόμετρο";}, two: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, few: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, many: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, other: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";} }) + "/εβδομάδα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a699172572 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν μίλια";}, one: function() { return number(d["0"]) + " δωρεάν μίλι";}, two: function() { return number(d["0"]) + " δωρεάν μίλια";}, few: function() { return number(d["0"]) + " δωρεάν μίλια";}, many: function() { return number(d["0"]) + " δωρεάν μίλια";}, other: function() { return number(d["0"]) + " δωρεάν μίλια";} }) + "/μήνα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1843136290 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, one: function() { return number(d["0"]) + " δωρεάν χιλιόμετρο";}, two: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, few: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, many: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, other: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";} }) + "/μήνα"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1635988916 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν μίλια";}, one: function() { return number(d["0"]) + " δωρεάν μίλι";}, two: function() { return number(d["0"]) + " δωρεάν μίλια";}, few: function() { return number(d["0"]) + " δωρεάν μίλια";}, many: function() { return number(d["0"]) + " δωρεάν μίλια";}, other: function() { return number(d["0"]) + " δωρεάν μίλια";} }) + "/συνολικά"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a360226758 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, one: function() { return number(d["0"]) + " δωρεάν χιλιόμετρο";}, two: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, few: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, many: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";}, other: function() { return number(d["0"]) + " δωρεάν χιλιόμετρα";} }) + "/συνολικά"; }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1693128066 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " προς " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b775886580 = messageFormatterFn((function(  ) {
  return function(d) { return "Πότε είναι η καλύτερη περίοδος για " + d["0"] + ";"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b702102805 = messageFormatterFn((function(  ) {
  return function(d) { return "Πότε είναι η καλύτερη περίοδος για " + d["0"] + ";"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a319916588 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν είστε βέβαιοι πότε να πάτε " + d["0"] + "; Δείτε παρακάτω τις τάσεις τιμών για το έτος."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1676341813 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν είστε βέβαιοι πότε να πάτε " + d["0"] + "; Δείτε παρακάτω τις τάσεις τιμών για το έτος."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b524866856 = messageFormatterFn((function(  ) {
  return function(d) { return "Περισσότερες λεπτομέρειες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b491843500 = messageFormatterFn((function(  ) {
  return function(d) { return "Εικόνα τάσης τιμών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a3634560 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση όλων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b277191795 = messageFormatterFn((function(  ) {
  return function(d) { return "Απόκρυψη όλων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a834600102 = messageFormatterFn((function(  ) {
  return function(d) { return "Κοινοποίηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1437334819 = messageFormatterFn((function(  ) {
  return function(d) { return "Email"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1792529700 = messageFormatterFn((function(  ) {
  return function(d) { return "Αντιγραφή συνδέσμου"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a7279073 = messageFormatterFn((function(  ) {
  return function(d) { return "Κοινοποίηση στο " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b879373487 = messageFormatterFn((function(  ) {
  return function(d) { return "Κοινοποίηση μέσω email"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1920900481 = messageFormatterFn((function(  ) {
  return function(d) { return "Δυστυχώς, παρουσιάστηκε κάποιο πρόβλημα στο σύστημά μας. Δοκιμάστε ξανά."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1905154973 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a377154455 = messageFormatterFn((function(  ) {
  return function(d) { return "Βρείτε την ιδανική διαμονή σας™"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1797272118 = messageFormatterFn((function(  ) {
  return function(d) { return "Παρόμοια καταλύματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1868075780 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " ξενοδοχεία";}, one: function() { return number(d["0"]) + " ξενοδοχείο";}, two: function() { return number(d["0"]) + " ξενοδοχεία";}, few: function() { return number(d["0"]) + " ξενοδοχεία";}, many: function() { return number(d["0"]) + " ξενοδοχεία";}, other: function() { return number(d["0"]) + " ξενοδοχεία";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.b1270223033 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["el-GR"], { zero: function() { return number(d["0"]) + " δραστηριότητες";}, one: function() { return number(d["0"]) + " δραστηριότητα";}, two: function() { return number(d["0"]) + " δραστηριότητες";}, few: function() { return number(d["0"]) + " δραστηριότητες";}, many: function() { return number(d["0"]) + " δραστηριότητες";}, other: function() { return number(d["0"]) + " δραστηριότητες";} }); }
})(messageFormat.number, messageFormat.plural, {"el-GR": Globalize("el-GR").pluralGenerator()}), Globalize("el-GR").pluralGenerator({}));
Globalize.a1979031401 = messageFormatterFn((function(  ) {
  return function(d) { return "Ο χάρτης δεν είναι διαθέσιμος αυτήν τη στιγμή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b464951764 = messageFormatterFn((function(  ) {
  return function(d) { return "Σχόλια για το κατάλυμα " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a149172188 = messageFormatterFn((function(  ) {
  return function(d) { return "Ειδικές οδηγίες check-in"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a644295372 = messageFormatterFn((function(  ) {
  return function(d) { return "Πολύγλωσσο προσωπικό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a505997560 = messageFormatterFn((function(  ) {
  return function(d) { return "Επισκέπτες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b84126979 = messageFormatterFn((function(  ) {
  return function(d) { return "Απλή μετάβαση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1804529084 = messageFormatterFn((function(  ) {
  return function(d) { return "Γήπεδο γκολφ στο κατάλυμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b5080526 = messageFormatterFn((function(  ) {
  return function(d) { return "Επαληθευμένο σχόλιο από την Expedia"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1210861746 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφία Trover «" + d["0"] + "» από τον/την " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14480023 = messageFormatterFn((function(  ) {
  return function(d) { return "7."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1077592037 = messageFormatterFn((function(  ) {
  return function(d) { return "Μεταφορά στο αεροδρόμιο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1139114404 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν πρωινό"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1993739569 = messageFormatterFn((function(  ) {
  return function(d) { return "Ολοκλήρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14477140 = messageFormatterFn((function(  ) {
  return function(d) { return "4."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a828863833 = messageFormatterFn((function(  ) {
  return function(d) { return "Προηγούμενες αναζητήσεις"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a549716381 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση περισσότερων περιοχών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1812958044 = messageFormatterFn((function(  ) {
  return function(d) { return "Πραγματοποιήστε αναζήτηση ξανά."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1721211616 = messageFormatterFn((function(  ) {
  return function(d) { return "υπάρχει 1 αποτέλεσμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b273444206 = messageFormatterFn((function(  ) {
  return function(d) { return "Κωδικός έκπτωσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2069365280 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1393898210 = messageFormatterFn((function(  ) {
  return function(d) { return "Τύπος καταλύματος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14478101 = messageFormatterFn((function(  ) {
  return function(d) { return "5."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1579998740 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν είμαστε σίγουροι τι συνέβη. Πραγματοποιήστε αναζήτηση ξανά."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b232282320 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπέιμπι-σίτινγκ ή φροντίδα παιδιών (επιπλέον χρέωση)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1500098105 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία παράδοσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2118246387 = messageFormatterFn((function(  ) {
  return function(d) { return "Λειτουργία ρεσεψιόν 24 ώρες το 24ωρο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b610019929 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή και των " + d["0"] + " καταλυμάτων κοντά σε " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a294846894 = messageFormatterFn((function(  ) {
  return function(d) { return "Business center"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1253358741 = messageFormatterFn((function(  ) {
  return function(d) { return "Με άμεση πρόσβαση σε πίστες σκι (Ski-in/ski-out)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a854881012 = messageFormatterFn((function(  ) {
  return function(d) { return "Μέρος γνωστό για"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a211675341 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν πάρκινγκ με παρκαδόρο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a545453161 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλα τα διαθέσιμα καταλύματα σε " + d["1"] + " από " + d["0"] + " ανά διανυκτέρευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1984320110 = messageFormatterFn((function(  ) {
  return function(d) { return "Υπηρεσίες concierge"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1546327750 = messageFormatterFn((function(  ) {
  return function(d) { return "Έλεγχος τιμών & διαθεσιμότητας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b539043528 = messageFormatterFn((function(  ) {
  return function(d) { return "Κατάλυμα μη καπνιστών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2032842803 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " μέση τιμή ανά διανυκτέρευση για ξενοδοχεία 4 αστέρων και πάνω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1813695285 = messageFormatterFn((function(  ) {
  return function(d) { return "Εξωτερική πισίνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1616196294 = messageFormatterFn((function(  ) {
  return function(d) { return "Μάθετε περισσότερα για: " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1453281596 = messageFormatterFn((function(  ) {
  return function(d) { return "Όλες οι παροχές"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a480909018 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζητάτε έναν άλλο προορισμό;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2024396765 = messageFormatterFn((function(  ) {
  return function(d) { return "Καμία προτίμηση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1556328021 = messageFormatterFn((function(  ) {
  return function(d) { return "Τιμή ανά διανυκτέρευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1588803450 = messageFormatterFn((function(  ) {
  return function(d) { return "Παραλαβή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1822307912 = messageFormatterFn((function(  ) {
  return function(d) { return "All-inclusive"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b237452307 = messageFormatterFn((function(  ) {
  return function(d) { return "Τρέχουσα τοποθεσία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a907778072 = messageFormatterFn((function(  ) {
  return function(d) { return "Σε ιδιωτική παραλία"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14474257 = messageFormatterFn((function(  ) {
  return function(d) { return "1."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1241769641 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " μέση τιμή/διανυκτέρευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b886522339 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " και " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1589696715 = messageFormatterFn((function(  ) {
  return function(d) { return "Κατηγορία καταλύματος (" + d["0"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2082137663 = messageFormatterFn((function(  ) {
  return function(d) { return "Τύπος καταλύματος (" + d["0"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2037714926 = messageFormatterFn((function(  ) {
  return function(d) { return "Λυπούμαστε, αλλά κάτι πήγε στραβά."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a913608023 = messageFormatterFn((function(  ) {
  return function(d) { return "Κατοικίδια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a947857575 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - Σχόλια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1277147567 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν ενσύρματη πρόσβαση (υψηλής ταχύτητας) στο ίντερνετ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1802296974 = messageFormatterFn((function(  ) {
  return function(d) { return "Φωτογραφία από " + d["0"] + " (" + d["1"] + ") / Κομμένη από την πρωτότυπη"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b169012824 = messageFormatterFn((function(  ) {
  return function(d) { return "υπάρχουν " + d["0"] + " αποτελέσματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a632218510 = messageFormatterFn((function(  ) {
  return function(d) { return "Περισσότερες επιλογές ταξιδιών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1393437368 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν μπορέσαμε να βρούμε την τρέχουσα τοποθεσία σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14476179 = messageFormatterFn((function(  ) {
  return function(d) { return "3."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b721212058 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακύρωση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1443293602 = messageFormatterFn((function(  ) {
  return function(d) { return "Πολλοί προορισμοί"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1781361102 = messageFormatterFn((function(  ) {
  return function(d) { return "τουλάχιστον"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1515984534 = messageFormatterFn((function(  ) {
  return function(d) { return "Μπέιμπι-σίτινγκ ή φροντίδα παιδιών (δωρεάν)"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1879707251 = messageFormatterFn((function(  ) {
  return function(d) { return "3 αστέρων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a448713685 = messageFormatterFn((function(  ) {
  return function(d) { return "10."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1791152239 = messageFormatterFn((function(  ) {
  return function(d) { return "Ακυρώστε και κλείστε το εργαλείο επιλογής ημερομηνίας χωρίς να αποθηκεύσετε τις αλλαγές. Ή επεξεργαστείτε τις ημερομηνίες παρακάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1826178786 = messageFormatterFn((function(  ) {
  return function(d) { return "Χάρτης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1975105259 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή λιγότερων δραστηριοτήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14481945 = messageFormatterFn((function(  ) {
  return function(d) { return "9."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a628313905 = messageFormatterFn((function(  ) {
  return function(d) { return "Δείτε όλα τα διαθέσιμα καταλύματα κοντά σε " + d["1"] + " από " + d["0"] + " ανά διανυκτέρευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b125747085 = messageFormatterFn((function(  ) {
  return function(d) { return "Ημερομηνία παραλαβής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a807638904 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση κατά θέμα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b88270703 = messageFormatterFn((function(  ) {
  return function(d) { return "4 αστέρων & πάνω"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1224891492 = messageFormatterFn((function(  ) {
  return function(d) { return "2 αστέρων & κάτω"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1958751818 = messageFormatterFn((function(  ) {
  return function(d) { return "Εστιατόριο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1356461871 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " μέση τιμή ανά διανυκτέρευση για ξενοδοχεία 3 αστέρων."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1752329182 = messageFormatterFn((function(  ) {
  return function(d) { return "Προορισμός"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2089065516 = messageFormatterFn((function(  ) {
  return function(d) { return "Τιμή ανά διανυκτέρευση (" + d["0"] + ")"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b892898151 = messageFormatterFn((function(  ) {
  return function(d) { return "Χάρτης " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a77975347 = messageFormatterFn((function(  ) {
  return function(d) { return "Τύποι πληρωμής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1474597565 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν στάθμευση χωρίς παρκαδόρο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1421189878 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση πτήσεων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a280012489 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1445596458 = messageFormatterFn((function(  ) {
  return function(d) { return "Κατηγορία καταλύματος"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1276367995 = messageFormatterFn((function(  ) {
  return function(d) { return "Εγκαταστάσεις πλυντηρίων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14479062 = messageFormatterFn((function(  ) {
  return function(d) { return "6."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14475218 = messageFormatterFn((function(  ) {
  return function(d) { return "2."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a14480984 = messageFormatterFn((function(  ) {
  return function(d) { return "8."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b119719799 = messageFormatterFn((function(  ) {
  return function(d) { return "Ενεργοποίηση υπηρεσιών γεωεντοπισμού"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1390372561 = messageFormatterFn((function(  ) {
  return function(d) { return "Προβολή περισσότερων δραστηριοτήτων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1824461970 = messageFormatterFn((function(  ) {
  return function(d) { return "Ώρα παραλαβής"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1343174354 = messageFormatterFn((function(  ) {
  return function(d) { return "Αναζήτηση ξενοδοχείων"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a2140983208 = messageFormatterFn((function(  ) {
  return function(d) { return "Παιδιά και επιπλέον κρεβάτια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a505758782 = messageFormatterFn((function(  ) {
  return function(d) { return "Δραστηριότητες"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b269850214 = messageFormatterFn((function(  ) {
  return function(d) { return "Business center 24ωρης λειτουργίας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1789469050 = messageFormatterFn((function(  ) {
  return function(d) { return "1 διανυκτέρευση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1412651162 = messageFormatterFn((function(  ) {
  return function(d) { return "Δωρεάν ασύρματο ίντερνετ"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1271827921 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιτρέπονται κατοικίδια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b886523300 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " και " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1210438538 = messageFormatterFn((function(  ) {
  return function(d) { return "Συνεδριακό κέντρο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1479205857 = messageFormatterFn((function(  ) {
  return function(d) { return "Εμφάνιση λιγότερων περιοχών"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1194360301 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " και " + d["2"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1194359340 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " και " + d["1"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a966003390 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " μέση τιμή ανά διανυκτέρευση για ξενοδοχεία 2 αστέρων και κάτω."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b2099263005 = messageFormatterFn((function(  ) {
  return function(d) { return "Παντοπωλείο/ψιλικατζίδικο"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a583408392 = messageFormatterFn((function(  ) {
  return function(d) { return "Εσωτερική πισίνα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b527634361 = messageFormatterFn((function(  ) {
  return function(d) { return "Θέλετε να δείτε τι υπάρχει στη γύρω περιοχή;"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b7227096 = messageFormatterFn((function(  ) {
  return function(d) { return "Οποιαδήποτε"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1119630344 = messageFormatterFn((function(  ) {
  return function(d) { return "Ανάκτηση της τρέχουσας τοποθεσίας σας"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b231805782 = messageFormatterFn((function(  ) {
  return function(d) { return "Συνδυάστε και εξοικονομήστε χρήματα"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a450110950 = messageFormatterFn((function(  ) {
  return function(d) { return "Ώρα παράδοσης"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a757424465 = messageFormatterFn((function(  ) {
  return function(d) { return "Κορυφαία ξενοδοχεία σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a843706032 = messageFormatterFn((function(  ) {
  return function(d) { return "Μέση τιμή ξενοδοχείου ανά διανυκτέρευση για 2 ενήλικες. </b>Όλες οι τιμές εμφανίζονται σε " + d["0"] + "."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b863253523 = messageFormatterFn((function(  ) {
  return function(d) { return "Περιορίστε την αναζήτησή σας σε ξενοδοχεία σε " + d["0"]; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b294158642 = messageFormatterFn((function(  ) {
  return function(d) { return "Επιστροφή"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b109500892 = messageFormatterFn((function(  ) {
  return function(d) { return "Διαφήμιση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a440332778 = messageFormatterFn((function(  ) {
  return function(d) { return "Νέα προσπάθεια"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a548048517 = messageFormatterFn((function(  ) {
  return function(d) { return "Σχετικά με αυτήν τη διαφήμιση"; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a651010909 = messageFormatterFn((function(  ) {
  return function(d) { return "Παρουσιάστηκε πρόβλημα κατά την ανάκτηση αυτών των πληροφοριών."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.a1754268655 = messageFormatterFn((function(  ) {
  return function(d) { return "Δεν μπορούμε να παράσχουμε τις πληροφορίες αυτήν τη στιγμή."; }
})(), Globalize("el-GR").pluralGenerator({}));
Globalize.b1680324836 = dateToPartsFormatterFn({"2":Globalize("el-GR").numberFormatter({"raw":"00"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1500096092 = dateToPartsFormatterFn({"2":Globalize("el-GR").numberFormatter({"raw":"00"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a2141092271 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1018638313 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1554237116 = dateToPartsFormatterFn({"2":Globalize("el-GR").numberFormatter({"raw":"00"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a594795441 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b943008164 = dateToPartsFormatterFn({"2":Globalize("el-GR").numberFormatter({"raw":"00"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1608378140 = dateToPartsFormatterFn({"2":Globalize("el-GR").numberFormatter({"raw":"00"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a2137872412 = dateToPartsFormatterFn({"2":Globalize("el-GR").numberFormatter({"raw":"00"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a1899520879 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a835817148 = dateToPartsFormatterFn({"2":Globalize("el-GR").numberFormatter({"raw":"00"}),"4":Globalize("el-GR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a657909699 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"Κ","mon":"Δ","tue":"Τ","wed":"Τ","thu":"Π","fri":"Π","sat":"Σ"}}}});
Globalize.b532997284 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Κυριακή","mon":"Δευτέρα","tue":"Τρίτη","wed":"Τετάρτη","thu":"Πέμπτη","fri":"Παρασκευή","sat":"Σάββατο"}}}});
Globalize.b1786242724 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Ιανουαρίου","2":"Φεβρουαρίου","3":"Μαρτίου","4":"Απριλίου","5":"Μαΐου","6":"Ιουνίου","7":"Ιουλίου","8":"Αυγούστου","9":"Σεπτεμβρίου","10":"Οκτωβρίου","11":"Νοεμβρίου","12":"Δεκεμβρίου"}}}});
Globalize.b717813500 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1177993777 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"}),"2":Globalize("el-GR").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1875980946 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"Ιαν","2":"Φεβ","3":"Μαρ","4":"Απρ","5":"Μαΐ","6":"Ιουν","7":"Ιουλ","8":"Αυγ","9":"Σεπ","10":"Οκτ","11":"Νοε","12":"Δεκ"}}}});
Globalize.a388250462 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Ιανουαρίου","2":"Φεβρουαρίου","3":"Μαρτίου","4":"Απριλίου","5":"Μαΐου","6":"Ιουνίου","7":"Ιουλίου","8":"Αυγούστου","9":"Σεπτεμβρίου","10":"Οκτωβρίου","11":"Νοεμβρίου","12":"Δεκεμβρίου"}}}});
Globalize.a1675031554 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"})}, {"pattern":"LLLL y","timeSeparator":":","months":{"L":{"4":{"1":"Ιανουάριος","2":"Φεβρουάριος","3":"Μάρτιος","4":"Απρίλιος","5":"Μάιος","6":"Ιούνιος","7":"Ιούλιος","8":"Αύγουστος","9":"Σεπτέμβριος","10":"Οκτώβριος","11":"Νοέμβριος","12":"Δεκέμβριος"}}}});
Globalize.a1675716747 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Ιαν","2":"Φεβ","3":"Μαρ","4":"Απρ","5":"Μαΐ","6":"Ιουν","7":"Ιουλ","8":"Αυγ","9":"Σεπ","10":"Οκτ","11":"Νοε","12":"Δεκ"}}}});
Globalize.a779334098 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Κυριακή","mon":"Δευτέρα","tue":"Τρίτη","wed":"Τετάρτη","thu":"Πέμπτη","fri":"Παρασκευή","sat":"Σάββατο"}}},"months":{"M":{"3":{"1":"Ιαν","2":"Φεβ","3":"Μαρ","4":"Απρ","5":"Μαΐ","6":"Ιουν","7":"Ιουλ","8":"Αυγ","9":"Σεπ","10":"Οκτ","11":"Νοε","12":"Δεκ"}}}});
Globalize.b2000882129 = dateToPartsFormatterFn({"1":Globalize("el-GR").numberFormatter({"raw":"0"})}, {"pattern":"E, d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"Κυρ","mon":"Δευ","tue":"Τρί","wed":"Τετ","thu":"Πέμ","fri":"Παρ","sat":"Σάβ"}}},"months":{"M":{"3":{"1":"Ιαν","2":"Φεβ","3":"Μαρ","4":"Απρ","5":"Μαΐ","6":"Ιουν","7":"Ιουλ","8":"Αυγ","9":"Σεπ","10":"Οκτ","11":"Νοε","12":"Δεκ"}}}});
Globalize.b1301611085 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a1878809843 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b338957818 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1461411776 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1932950867 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1885254648 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b564294413 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1987091891 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1778381133 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b580529210 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1214530899 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a506736332 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1369157837 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1672564019 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b134529907 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"d"}));
Globalize.b1569400858 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b1991127781 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b756525145 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a2053745305 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a2054430498 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a161603547 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1622168378 = dateFormatterFn(Globalize("el-GR").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a312450658 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b802095710 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b1128338827 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a2044174511 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b747954686 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1620331639 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1049767330 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b693813662 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b164319390 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b1369910219 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1466374654 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b1982096195 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^Κ/],["mon",/^Δ/],["tue",/^Τ/],["wed",/^Τ/],["thu",/^Π/],["fri",/^Π/],["sat",/^Σ/]]});
Globalize.a2014240546 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["fri",/^Παρασκευή/],["sun",/^Κυριακή/],["mon",/^Δευτέρα/],["wed",/^Τετάρτη/],["sat",/^Σάββατο/],["thu",/^Πέμπτη/],["tue",/^Τρίτη/]]});
Globalize.a760995106 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^Φεβρουαρίου/],["9",/^Σεπτεμβρίου/],["1",/^Ιανουαρίου/],["12",/^Δεκεμβρίου/],["8",/^Αυγούστου/],["10",/^Οκτωβρίου/],["11",/^Νοεμβρίου/],["4",/^Απριλίου/],["3",/^Μαρτίου/],["6",/^Ιουνίου/],["7",/^Ιουλίου/],["5",/^Μαΐου/]]});
Globalize.b1692316930 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1413797867 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b692135284 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["6",/^Ιουν/],["7",/^Ιουλ/],["1",/^Ιαν/],["2",/^Φεβ/],["3",/^Μαρ/],["4",/^Απρ/],["5",/^Μαΐ/],["8",/^Αυγ/],["9",/^Σεπ/],["10",/^Οκτ/],["11",/^Νοε/],["12",/^Δεκ/]]});
Globalize.a2034748632 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^Φεβρουαρίου/],["9",/^Σεπτεμβρίου/],["1",/^Ιανουαρίου/],["12",/^Δεκεμβρίου/],["8",/^Αυγούστου/],["10",/^Οκτωβρίου/],["11",/^Νοεμβρίου/],["4",/^Απριλίου/],["3",/^Μαρτίου/],["6",/^Ιουνίου/],["7",/^Ιουλίου/],["5",/^Μαΐου/]]});
Globalize.b627160248 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"LLLL y","digitsRe":/\d/,"gregorian/months/stand-alone/wide":[["2",/^Φεβρουάριος/],["9",/^Σεπτέμβριος/],["1",/^Ιανουάριος/],["12",/^Δεκέμβριος/],["8",/^Αύγουστος/],["10",/^Οκτώβριος/],["11",/^Νοέμβριος/],["4",/^Απρίλιος/],["3",/^Μάρτιος/],["6",/^Ιούνιος/],["7",/^Ιούλιος/],["5",/^Μάιος/]]});
Globalize.b626475055 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["6",/^Ιουν/],["7",/^Ιουλ/],["1",/^Ιαν/],["2",/^Φεβ/],["3",/^Μαρ/],["4",/^Απρ/],["5",/^Μαΐ/],["8",/^Αυγ/],["9",/^Σεπ/],["10",/^Οκτ/],["11",/^Νοε/],["12",/^Δεκ/]]});
Globalize.b1778856756 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE, d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["fri",/^Παρασκευή/],["sun",/^Κυριακή/],["mon",/^Δευτέρα/],["wed",/^Τετάρτη/],["sat",/^Σάββατο/],["thu",/^Πέμπτη/],["tue",/^Τρίτη/]],"gregorian/months/format/abbreviated":[["6",/^Ιουν/],["7",/^Ιουλ/],["1",/^Ιαν/],["2",/^Φεβ/],["3",/^Μαρ/],["4",/^Απρ/],["5",/^Μαΐ/],["8",/^Αυγ/],["9",/^Σεπ/],["10",/^Οκτ/],["11",/^Νοε/],["12",/^Δεκ/]]});
Globalize.b8106635 = dateParserFn(Globalize("el-GR").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"E, d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^Κυρ/],["mon",/^Δευ/],["tue",/^Τρί/],["wed",/^Τετ/],["thu",/^Πέμ/],["fri",/^Παρ/],["sat",/^Σάβ/]],"gregorian/months/format/abbreviated":[["6",/^Ιουν/],["7",/^Ιουλ/],["1",/^Ιαν/],["2",/^Φεβ/],["3",/^Μαρ/],["4",/^Απρ/],["5",/^Μαΐ/],["8",/^Αυγ/],["9",/^Σεπ/],["10",/^Οκτ/],["11",/^Νοε/],["12",/^Δεκ/]]});
module.exports = Globalize;
